type Dict = Record<string, string>;

const ar: Dict = {
  appName: "وين نروح",
  tagline: "طلعتك الجاية تبدأ من هنا",
  "hero.eyebrow": "سهرات · فروسية · دراجات نارية · فنون وورش",
  "hero.title": "وين نروح اليوم؟",
  "pp.partners": "أماكن الشركاء",
  "pp.platform": "أماكن المنصة",
  "err.The location must be inside Iraq": "الموقع لازم يكون داخل العراق",
  "err.Pick the place location on the map": "حدّد موقع المكان على الخريطة",
  "err.This place has upcoming events": "ما ينطفي لأن بيه فعاليات جاية. ألغِها أو انتظر تخلص أول.",
  "err.This place does not offer events": "هذا المكان ما يقدّم فعاليات. الإدارة تحدد هذا.",
  "pp.f.image": "الصورة الرئيسية",
  "pp.f.gallery": "الصور",
  "pp.f.lng": "خط الطول",
  "pp.f.lat": "خط العرض",
  "pp.f.description_en": "الوصف بالإنكليزي",
  "pp.f.description_ar": "الوصف",
  "pp.f.hours_ar": "أوقات الدوام",
  "pp.f.address": "العنوان",
  "pp.f.area_en": "المنطقة بالإنكليزي",
  "pp.f.area": "المنطقة",
  "pp.f.city": "المدينة",
  "pp.f.governorate": "المحافظة",
  "pp.f.type": "التصنيف",
  "pp.f.name_en": "الاسم بالإنكليزي",
  "pp.f.name_ar": "الاسم",
  "pp.gpsPicked": "انحدد موقعك. اضغط حفظ حتى ينرسل.",
  "pp.photosN": "{n} صورة",
  "pp.changes": "التعديلات المطلوبة",
  "pp.editBadge": "تعديل",
  "pp.editSent": "انرسل التعديل لموافقة الإدارة",
  "pp.editHint": "أي تعديل تحفظه يروح لموافقة الإدارة قبل ما يظهر للزبائن.",
  "pp.editRejected": "ما انقبل آخر تعديل: {r}. المعلومات القديمة باقية ظاهرة.",
  "pp.editPending": "تعديلاتك بانتظار موافقة الإدارة. المعلومات القديمة باقية ظاهرة للزبائن لحد الموافقة.",
  "pp.eventsOffToast": "انطفت الفعاليات لهذا المكان",
  "pp.eventsOnToast": "صار المكان يقدر يضيف فعاليات",
  "pp.eventsQuestion": "هذا المكان يقدّم فعاليات؟",
  "pp.eventsShort": "فعاليات",
  "pp.eventsOff": "بدون فعاليات",
  "pp.eventsOn": "يقدّم فعاليات",
  "pp.suggestSent": "انرسل اقتراح المكان للإدارة",
  "pp.suggestHint": "نفس معلومات المكان العام. بعد موافقة الإدارة يظهر للزبائن ضمن الأماكن العامة، والإدارة تحدد إذا يقدّم فعاليات.",
  "pp.suggestTitle": "اقتراح مكان عام",
  "pp.noLocationPartner": "حدّد موقع المكان على الخريطة من «تعديل» حتى يظهر للزبائن ضمن الأماكن العامة.",
  "pp.noLocationAdmin": "بدون موقع: ما يظهر بالأماكن العامة",
  "hero.subtitle": "اكتشف أحلى الفعاليات والأماكن بالعراق، من الأمسيات والرياضة للنزهات العائلية والفنون، واحجز بلمسة.",
  "hero.cta": "استكشف الفعاليات",
  "hero.ctaSpots": "استكشف الأماكن العامة",
  "hero.partner": "عندك مكان؟ انضم لنا",
  "explore.title": "أماكن تستاهل الزيارة",
  "explore.empty": "ما فيه أماكن في هذا التصنيف حالياً، جرّب تصنيف ثاني",
  "type.all": "الكل",
  "type.restaurant": "مطاعم",
  "type.event": "فعاليات",
  "type.cinema": "سينما",
  "type.sports": "رياضة",
  "type.trips": "رحلات",
  "type.other": "أنشطة أخرى",
  "nav.home": "استكشف",
  "nav.bookings": "حجوزاتي",
  "nav.profile": "حسابي",
  "nav.myVenues": "أماكني العامة",
  "nav.venueBookings": "الحجوزات",
  "nav.team": "فريق العمل",
  "nav.settings": "الإعدادات",
  "nav.adminVenues": "الشركاء",
  "nav.adminPartners": "الشركاء",
  "nav.partnersShort": "الشركاء",
  "nav.adminPlaces": "أماكن عامة",
  "ap.title": "أماكن عامة",
  "ap.sub": "أماكن الشركاء العامة، والجديدة بانتظار موافقتك. بعد الموافقة تظهر للزبائن ضمن الأماكن العامة.",
  "ap.all": "كل أماكن الشركاء العامة",
  "ap.empty": "لا توجد أماكن بعد",
  "ap.view": "عرض الصفحة",
  "ap.partnerDisabled": "الشريك معطّل",
  "bookings.location": "الموقع",
  "nav.adminBookings": "كل الحجوزات",
  "nav.adminCases": "الحالات",
  "nav.checkinShort": "الوصول",
  "nav.bookingsShort": "الحجوزات",
  "nav.auditShort": "التدقيق",
  "nav.financeShort": "المالية",
  "nav.venuesShort": "أماكن عامة",
  "err.The exchange rate must be a number": "سعر الصرف لازم يكون رقم أكبر من صفر",
  "b6.approveDispute": "قبول الاعتراض",
  "b6.rejectedNote": "انرفض طلبك السابق. تكدر ترسل توضيح جديد للإدارة",
  "role.customer": "عميل",
  "role.venue": "شريك",
  "role.admin": "مدير المنصة",
  "role.owner": "مالك",
  "role.staff": "استقبال",
  "auth.login": "تسجيل الدخول",
  "auth.logout": "تسجيل الخروج",
  "auth.google": "الدخول عبر Google",
  "auth.customerTitle": "يا هلا! سجّل دخولك",
  "auth.customerSub": "ادخل برقم هاتفك وكلمة المرور حتى ترسل طلبات الحجز وتتابعها.",
  "auth.partnerLink": "دخول الشركاء والإدارة",
  "auth.partnerTitle": "دخول الشركاء والإدارة",
  "auth.partnerSub": "سجّل دخولك باسم المستخدم وكلمة المرور.",
  "auth.email": "البريد الإلكتروني",
  "auth.password": "كلمة المرور",
  "auth.submit": "دخول",
  "auth.noAccount": "ما عندك حساب شريك؟",
  "auth.registerLink": "سجّل كشريك",
  "auth.customerLink": "أنت عميل؟ ادخل من هنا",
  "auth.registerTitle": "سجّل كشريك في وين نروح",
  "auth.registerSub": "بعد التسجيل يراجع فريقنا طلبك ونفعّل حسابك.",
  "auth.businessName": "اسم الشريك",
  "auth.fullName": "اسمك",
  "auth.phone": "رقم الهاتف",
  "auth.city": "المحافظة",
  "auth.registerSubmit": "أرسل الطلب",
  "auth.haveAccount": "عندك حساب؟",
  "auth.signingIn": "لحظات ونجهز لك كل شي...",
  "pending.title": "طلبك قيد المراجعة",
  "pending.body": "استلمنا طلب تسجيلك كشريك، وبيراجعه فريقنا قريب. بنرسل لك إشعار أول ما يتفعل الحساب.",
  "rejected.title": "لم تتم الموافقة على الطلب",
  "rejected.body": "للأسف ما تمت الموافقة على حساب الشريك. تواصل مع الدعم لمزيد من التفاصيل.",
  "status.pending": "قيد المراجعة",
  "status.approved": "نشط",
  "status.rejected": "مرفوض",
  "status.confirmed": "مؤكد",
  "status.cancelled": "ملغي",
  "venue.spots": "مكان",
  "venue.book": "احجز الآن",
  "booking.title": "احجز مكانك",
  "booking.date": "التاريخ",
  "booking.guests": "عدد الأشخاص",
  "booking.confirm": "تأكيد الحجز",
  "booking.success": "تم الحجز! تذكرتك جاهزة في حجوزاتي",
  "booking.loginNeeded": "سجّل دخولك كعميل عشان تحجز",
  "booking.noPayment": "الدفع يكون في المكان — ما فيه دفع إلكتروني حالياً",
  "bookings.title": "حجوزاتي",
  "bookings.empty": "ما عندك حجوزات للحين. يلا نختار لك طلعة حلوة!",
  "bookings.showQr": "عرض التذكرة",
  "bookings.code": "رمز الحجز",
  "bookings.offline": "أنت غير متصل — نعرض لك التذاكر المحفوظة على جهازك",
  "bookings.savedOffline": "محفوظة على جهازك وتشتغل بدون إنترنت",
  "bookings.copy": "نسخ الرمز",
  "bookings.copied": "تم نسخ الرمز",
  "bookings.saveImage": "حفظ الصورة",
  "bookings.cancel": "إلغاء الحجز",
  "bookings.cancelled": "تم إلغاء الحجز",
  "bookings.guests": "أشخاص",
  "bookings.customer": "العميل",
  "bookings.venue": "المكان",
  "bookings.emptyVenue": "ما فيه حجوزات حالياً",
  "notif.title": "الإشعارات",
  "notif.empty": "ما فيه إشعارات جديدة",
  "notif.markRead": "تحديد الكل كمقروء",
  "profile.title": "حسابي",
  "settings.title": "الإعدادات",
  "settings.language": "اللغة",
  "settings.theme": "الوضع الليلي",
  "settings.account": "معلومات الحساب",
  "settings.platform": "إعدادات المنصة",
  "settings.platformSoon": "إعدادات المنصة المتقدمة قادمة في المرحلة الجاية.",
  "myVenues.title": "أماكني العامة",
  "myVenues.sub": "عدّل معلومات أماكنك العامة وصورها وموقعها بأي وقت. بعد موافقة الإدارة تظهر للزبائن ضمن الأماكن العامة.",
  "myVenues.add": "اقتراح مكان عام",
  "myVenues.empty": "ما أضفت أماكن للحين",
  "myVenues.nameAr": "الاسم بالعربي",
  "myVenues.nameEn": "الاسم بالإنجليزي",
  "myVenues.type": "التصنيف",
  "vc.title": "تصنيفات الأماكن",
  "vc.sub": "الشريك يختار تصنيف مكانه من هالقائمة بس.",
  "vc.readOnly": "إدارة التصنيفات للمدير العام فقط.",
  "vc.new": "تصنيف جديد",
  "vc.edit": "تعديل التصنيف",
  "vc.delete": "حذف التصنيف",
  "vc.saved": "انحفظ التصنيف",
  "vc.deleted": "انحذف التصنيف",
  "vc.count": "{n} مكان",
  "vc.inUse": "ما ينحذف لأن عليه أماكن ({n}). غيّر تصنيف الأماكن أول.",
  "vc.confirmDelete": "تحذف تصنيف «{name}» نهائياً؟",
  "err.Choose a valid category": "اختار تصنيف من القائمة",
  "err.This category already exists": "هذا المعرّف موجود، اختار معرّف ثاني",
  "err.This category is used by venues": "ما ينحذف لأن عليه أماكن",
  "err.Category not found": "التصنيف مو موجود",
  "myVenues.image": "رابط الصورة",
  "myVenues.description": "الوصف",
  "myVenues.created": "تمت إضافة المكان وأُرسل لإدارة المنصة للموافقة",
  "myVenues.booked": "محجوز",
  "team.title": "فريق العمل",
  "team.sub": "أضف موظفينك تحت نفس حساب الشريك.",
  "team.add": "إضافة عضو",
  "team.added": "تمت إضافة العضو",
  "team.removed": "تم حذف العضو",
  "team.remove": "حذف",
  "team.role": "الصلاحية",
  "team.you": "أنت",
  "team.ownerOnly": "المالك فقط يقدر يدير الفريق",
  "admin.venuesTitle": "إدارة الشركاء",
  "admin.whatsapp": "تواصل واتساب",
  "admin.waMsg": "هلا بيكم، معكم إدارة منصة وين نروح بخصوص طلب تسجيل «{name}» كشريك.",
  "admin.venuesSub": "راجع طلبات الشركاء الجديدة ووافق عليها.",
  "admin.approve": "موافقة وتفعيل",
  "admin.reject": "رفض",
  "admin.venuesCount": "أماكن",
  "admin.empty": "ما فيه شركاء مسجلين",
  "admin.bookingsTitle": "كل الحجوزات",
  "common.save": "حفظ",
  "common.cancel": "إلغاء",
  "common.loading": "جاري التحميل...",
  "common.error": "صار خطأ، حاول مرة ثانية",
  "common.dashboard": "لوحتي",
  "common.back": "رجوع",
  "np.title": "التنبيهات",
  "np.reminders.title": "تذكير قبل الفعالية",
  "np.reminders.sub": "نذكّرك بحجوزاتك المؤكّدة قبل يوم وقبل ساعتين.",
  "np.fav_events.title": "فعاليات أماكني المفضلة",
  "np.fav_events.sub": "نبّهني كل ما تنضاف فعالية جديدة بمكان حاطّه بالمفضلة.",
  "np.on": "انحفظ: التنبيه شغّال",
  "np.off": "انحفظ: التنبيه طافي",
  "pe.share": "شارك الفعالية بالواتساب",
  "fe.title": "فعاليات أماكني المفضلة",
  "fe.sub": "نبّهني كل ما تنضاف فعالية جديدة بمكان حاطّه بالمفضلة.",
  "fe.on": "راح نبلّغك بالفعاليات الجديدة",
  "fe.off": "انطفى تنبيه الفعاليات الجديدة",
  "about.share": "شارك التطبيق ويا أصدقائك",
  "about.shareMsg": "جرّب تطبيق «وين نروح» — تلكى بيه الأماكن العامة والفعاليات وتحجز بسهولة:",
  "legal.privacy": "سياسة الخصوصية",
  "legal.terms": "شروط الاستخدام",
  "legal.updated": "آخر تحديث:",
  "legal.empty": "راح تنضاف قريباً.",
  "legal.agree1": "أوافق على",
  "legal.and": "و",
  "legal.adminTitle": "شروط الاستخدام وسياسة الخصوصية",
  "legal.saved": "انحفظ النص",
  "pe.title": "الفعاليات الجاية بهذا المكان",
  "pe.all": "عرض الكل ({n})",
  "pe.less": "عرض أقل",
  "err.You must accept the terms and privacy policy": "لازم توافق على شروط الاستخدام وسياسة الخصوصية",
  "about.title": "عن وين نروح",
  "about.version": "النسخة",
  "about.contact": "تواصل ويانا",
  "about.whatsapp": "واتساب الإدارة",
  "about.facebook": "صفحتنا على فيسبوك",
  "about.default": "«وين نروح» يساعدك تلكى الأماكن العامة والفعاليات القريبة منك وتحجز بسهولة.",
  "about.adminTitle": "صفحة «عن وين نروح»",
  "about.adminNote": "النص اللي يظهر بالصفحة ورابط فيسبوك. رقم الواتساب ينأخذ من رقم تواصل الإدارة.",
  "about.textAr": "نص التعريف بالعربي",
  "about.textEn": "نص التعريف بالإنكليزي (اختياري)",
  "about.saved": "انحفظت صفحة «عن وين نروح»",
  "err.Enter a valid Facebook link": "اكتب رابط فيسبوك صحيح",
  "nav.checkin": "تسجيل الوصول",
  "details.back": "رجوع",
  "details.about": "عن المكان",
  "details.location": "الموقع",
  "details.openMap": "افتح في الخرائط",
  "details.noLocation": "الموقع غير محدد بعد",
  "details.notFound": "ما لقينا هذا المكان",
  "details.photos": "صور",
  "myVenues.edit": "تعديل",
  "edit.title": "تعديل المكان",
  "edit.photos": "صور المكان",
  "edit.photosHint": "أول صورة هي الغلاف. JPG أو PNG أو WEBP حتى 8MB",
  "edit.upload": "رفع صور",
  "edit.uploading": "جاري الرفع...",
  "edit.cover": "الغلاف",
  "edit.makeCover": "اجعلها غلاف",
  "edit.remove": "حذف",
  "edit.location": "موقع المكان",
  "edit.locationHint": "وأنت داخل المكان اضغط «ثبّت موقعي الحالي»، أو اضغط على الخريطة لتحديده يدوياً",
  "edit.gpsButton": "ثبّت موقعي الحالي",
  "edit.gpsLocating": "جارٍ تحديد موقعك…",
  "edit.gpsSaved": "تم تثبيت موقع المكان وحفظه",
  "edit.gpsDenied": "اسمح للتطبيق بالوصول إلى موقعك من إعدادات المتصفح ثم حاول مرة أخرى",
  "edit.gpsFailed": "تعذّر تحديد موقعك، تأكد من تشغيل الـGPS وحاول مرة أخرى",
  "edit.gpsUnsupported": "جهازك لا يدعم تحديد الموقع",
  "edit.address": "العنوان",
  "edit.descEn": "الوصف بالإنجليزي",
  "edit.saved": "تم حفظ التعديلات",
  "edit.viewPublic": "عرض صفحة المكان",
  "edit.details": "التفاصيل",
  "checkin.title": "تسجيل الوصول",
  "checkin.sub": "امسح رمز QR من تذكرة العميل أو أدخل رمز الحجز يدوياً",
  "checkin.startCam": "تشغيل الكاميرا",
  "checkin.stopCam": "إيقاف الكاميرا",
  "checkin.manual": "أو أدخل رمز الحجز",
  "checkin.find": "بحث",
  "checkin.confirm": "تأكيد الوصول",
  "checkin.done": "تم تسجيل الوصول بنجاح",
  "checkin.already": "تم تسجيل وصول هذا الحجز مسبقاً",
  "checkin.cancelledNote": "هذا الحجز ملغي ولا يمكن تسجيل وصوله",
  "checkin.camError": "ما قدرنا نشغل الكاميرا، استخدم الإدخال اليدوي",
  "checkin.at": "وقت الوصول",
  "checkin.by": "بواسطة",
  "checkin.scanAgain": "مسح تذكرة أخرى",
  "status.checked_in": "تم الوصول",
  "err.Booking not found": "الحجز غير موجود لدى حسابك كشريك",
  "err.Already checked in": "تم تسجيل وصول هذا الحجز مسبقاً",
  "err.Booking is cancelled": "هذا الحجز ملغي",
  "err.Only JPG, PNG or WEBP images are allowed": "الصور المسموحة: JPG أو PNG أو WEBP",
  "err.Image is larger than 8MB": "حجم الصورة أكبر من 8MB",
  "reminder.button": "تذكير",
  "reminder.title": "ذكّرني بحجزي",
  "reminder.sub": "اختر الوقت اللي يناسبك، ونرسل لك تنبيه داخل التطبيق مع تذكرتك",
  "reminder.at": "وقت التذكير",
  "reminder.repeat": "التكرار",
  "reminder.repeat.none": "مرة وحدة",
  "reminder.repeat.1h": "كل ساعة",
  "reminder.repeat.3h": "كل 3 ساعات",
  "reminder.repeat.daily": "كل يوم",
  "reminder.repeatHint": "يتوقف التكرار تلقائياً بعد وصولك أو انتهاء موعد الحجز أو إلغائه",
  "reminder.save": "حفظ التذكير",
  "reminder.remove": "إلغاء التذكير",
  "reminder.saved": "تم ضبط التذكير",
  "reminder.removed": "تم إلغاء التذكير",
  "reminder.chip": "تذكير",
  "reminder.ended": "انتهى التذكير",
  "explore.list": "قائمة",
  "explore.map": "خريطة",
  "explore.nearMe": "قريب مني",
  "explore.locating": "نحدد موقعك...",
  "explore.locError": "ما قدرنا نحدد موقعك، تأكد من السماح بالوصول للموقع",
  "explore.youAreHere": "أنت هنا",
  "explore.km": "كم",
  "explore.details": "التفاصيل",
  "err.Reminders are only for upcoming bookings": "التذكير متاح للحجوزات القادمة فقط",
  "err.Reminder time must be in the future and before the booking ends": "اختر وقت قادم وقبل انتهاء يوم الحجز",
  "search.placeholder": "ابحث عن فعالية، مكان، منطقة، فنان أو برنامج...",
  "search.clear": "مسح البحث",
  "search.empty": "ما لقينا نتائج لـ",
  "share.whatsapp": "مشاركة واتساب",
  "share.more": "مشاركة",
  "share.text": "يلا نطلع سوا! 🎉 حجزت في {venue} يوم {date} لـ {guests} أشخاص. تفاصيل المكان:",
  "nav.favorites": "المفضلة",
  "fav.add": "أضف للمفضلة",
  "fav.remove": "إزالة من المفضلة",
  "fav.added": "انضاف للمفضلة",
  "fav.removed": "انشال من المفضلة",
  "fav.title": "مفضلتك",
  "fav.sub": "الفعاليات والأماكن العامة اللي حفظتها عشان ترجع لها بسرعة",
  "fav.empty": "ما حفظت أي مكان للحين. اضغط على القلب في أي مكان يعجبك",
  "b4.filters": "الفلاتر",
  "b4.allAreas": "كل المناطق",
  "b4.anyPrice": "أي سعر",
  "b4.free": "مجاني فقط",
  "b4.iqd": "بالدينار (IQD)",
  "b4.usd": "بالدولار (USD)",
  "b4.min": "من",
  "b4.max": "إلى",
  "b4.sortDate": "الأقرب موعداً",
  "b4.sortPrice": "الأقل سعراً",
  "b4.currencyNote": "نقارن الأسعار بنفس العملة فقط، بدون أي تحويل بين الدينار والدولار",
  "b4.anyAudience": "كل الفئات",
  "b4.anyCategory": "كل الدرجات",
  "b4.anyProgram": "كل البرامج",
  "b4.clear": "مسح الفلاتر",
  "b4.count": "{n} فعالية",
  "b4.countOne": "فعالية وحدة",
  "b4.minMax": "الحد الأدنى لازم يكون أقل من الحد الأعلى",
  "fav.loginNeededEvent": "سجّل دخولك كعميل عشان تحفظ فعالياتك المفضلة",
  "b4.matched": "يبدأ من",
  "cal.add": "أضف للتقويم",
  "cal.google": "تقويم Google",
  "cal.ics": "ملف تقويم (Apple / Outlook)",
  "share.event": "شوف هالفعالية على وين نروح 🎉 {title} — {date}",
  "share.copyLink": "نسخ الرابط",
  "share.venue": "شوف هالمكان على وين نروح 🎉 {name}",
  "share.copied": "انتسخ الرابط",
  "fav.tabEvents": "الفعاليات",
  "fav.tabVenues": "الأماكن",
  "fav.emptyEvents": "ما حفظت أي فعالية للحين. اضغط على القلب في أي فعالية تعجبك",
  "edit.area": "المنطقة",
  "bst.pending": "بانتظار التأكيد",
  "bst.confirmed": "مؤكد",
  "bst.rejected": "مرفوض",
  "bst.unable_to_contact": "تعذّر التواصل",
  "bst.expired": "انتهت مهلة التأكيد",
  "bst.cancelled": "ملغي",
  "bst.attended": "حضر",
  "bst.completed": "مكتمل",
  "bst.no_show": "لم يحضر",
  "bst.checked_in": "تم الوصول",
  "b5.deadline": "المكان راح يأكد قبل {time}",
  "b5.noQrYet": "تذكرة QR تطلع بعد ما يأكد المكان طلبك",
  "b5.reason": "السبب",
  "b5.reasonPh": "اكتب السبب بوضوح",
  "b5.optional": "(اختياري)",
  "b5.confirm": "تأكيد",
  "b5.reject": "رفض",
  "b5.unable": "تعذّر التواصل",
  "b5.whatsapp": "واتساب الزبون",
  "ve.f.autoClose": "إغلاق الطلبات تلقائياً في (اختياري)",
  "ve.f.autoCloseHint": "اتركه فارغاً لتبقى الطلبات مفتوحة حتى تغلقها يدوياً أو تنتهي الفعالية.",
  "ve.f.autoCloseClear": "إزالة",
  "ve.autoCloseAt": "تُغلق الطلبات تلقائياً {when}",
  "pc.floating": "استفسر على واتساب",
  "pc.msgUser": "هلا، أتواصل وياكم من تطبيق وين نروح.\nالاسم: {name}\nالحساب: {email}\nالنوع: {role}",
  "pc.msgPartner": "\nالشريك: {business}",
  "vr.title": "أماكن عامة بانتظار الموافقة",
  "vr.whatsapp": "واتساب الشريك",
  "vr.waMsg": "هلا {business}، معكم إدارة منصة وين نروح بخصوص المكان «{place}» اللي أضفتوه. نود نتأكد من بعض التفاصيل قبل الموافقة.",
  "vr.approve": "موافقة",
  "vr.reject": "رفض",
  "vr.approved": "تمت الموافقة على المكان",
  "vr.rejected": "تم رفض المكان",
  "vr.resubmitted": "أُعيد إرساله",
  "vr.hidden": "مخفي · غير مفعّل",
  "vr.noApproved": "لا يوجد مكان مفعّل بعد. الأماكن تظهر هنا بعد موافقة إدارة المنصة.",
  "vr.resubmittedToast": "تم الحفظ وأُعيد إرسال المكان للمراجعة",
  "vr.pendingNote": "بانتظار موافقة إدارة المنصة. المكان مخفي عن الزبائن ولا يمكن إضافة فعاليات له حتى تتم الموافقة.",
  "vr.rejectedNote": "لم تتم الموافقة — السبب: {r}. عدّل المكان واحفظه ليرجع للمراجعة.",
  "err.This place is waiting for admin approval": "هذا المكان بانتظار موافقة الإدارة",
  "err.This place is no longer pending review": "هذا المكان لم يعد بانتظار المراجعة",
  "rr.title": "أسباب رفض الأماكن الجاهزة",
  "rr.note": "تظهر كأزرار سريعة عند رفض مكان. الضغط على السبب يكتبه، وتقدر تعدّله قبل الإرسال.",
  "rr.add": "سبب جديد",
  "rr.saved": "تم حفظ الأسباب",
  "rr.ph": "اكتب السبب",
  "err.Each reason must be 3 to 300 characters": "كل سبب لازم يكون من 3 إلى 300 حرف",
  "nav.accounts": "سجل الحسابات",
  "nav.accountsShort": "الحسابات",
  "reg.title": "سجل الحسابات",
  "reg.sub": "كل الشركاء والزبائن مع وسائل التواصل وإدارة الحساب.",
  "reg.partners": "الشركاء",
  "reg.customers": "الزبائن",
  "reg.search": "ابحث بالاسم أو البريد أو الهاتف",
  "reg.empty": "لا توجد حسابات",
  "reg.joined": "سجّل في {d}",
  "reg.noPhone": "لا يوجد رقم هاتف",
  "reg.wa": "واتساب",
  "common.close": "إغلاق",
  "reg.waMsg": "هلا {name}، معك إدارة منصة وين نروح.",
  "reg.disable": "تعطيل الحساب",
  "reg.enable": "تفعيل الحساب",
  "reg.disabled": "تم تعطيل الحساب",
  "reg.enabled": "تم تفعيل الحساب",
  "reg.disabledBadge": "معطّل",
  "reg.disableNotePartner": "يُمنع كل فريق الشريك من الدخول، وتختفي أماكنه وفعالياته عن الزبائن. الحجوزات القائمة تبقى محفوظة.",
  "reg.disableNoteCustomer": "يُمنع الزبون من الدخول. الحجوزات القائمة تبقى محفوظة.",
  "reg.delete": "حذف",
  "reg.deleteTitle": "حذف حساب «{name}»",
  "reg.blockedPartner": "لا يمكن حذف الشريك وعنده أماكن أو فعاليات قادمة أو حجوزات قائمة. ألغِ الفعاليات ثم احذف الأماكن تدريجياً من هنا.",
  "reg.blockedCustomer": "لا يمكن حذف الزبون وعنده حجوزات قائمة. ألغِ الحجوزات أولاً من هنا.",
  "reg.upcomingEvents": "الفعاليات القادمة",
  "reg.activeBookings": "{n} حجز قائم",
  "reg.cancelEvent": "إلغاء الفعالية",
  "reg.places": "الأماكن العامة",
  "reg.placeHasEvents": "عنده {n} فعالية قادمة — ألغها أولاً",
  "reg.placeFree": "جاهز للحذف",
  "reg.deletePlace": "حذف المكان",
  "reg.placeDeleted": "تم حذف المكان",
  "reg.activeBookingsTitle": "الحجوزات القائمة",
  "reg.cancelBooking": "إلغاء الحجز",
  "reg.cancelled": "تم الإلغاء",
  "reg.deleteWarn": "سيتم حذف الحساب وكل بياناته نهائياً (الحجوزات السابقة والسجل المالي والإشعارات). لا يمكن التراجع.",
  "reg.deleteForever": "حذف نهائي",
  "reg.deleted": "تم حذف الحساب نهائياً",
  "err.Account disabled": "هذا الحساب معطّل. تواصل مع إدارة المنصة",
  "err.Delete this partner's places, upcoming events and active bookings first": "احذف أماكن الشريك وألغِ فعالياته القادمة وحجوزاته أولاً",
  "err.Cancel this customer's active bookings first": "ألغِ حجوزات الزبون القائمة أولاً",
  "err.Cancel this place's upcoming events first": "ألغِ فعاليات المكان القادمة أولاً",
  "fm.per_booking": "على أساس الحجز",
  "fm.per_booking.hint": "مبلغ ثابت لكل حجز حضر أصحابه فعلاً",
  "fm.per_event": "على أساس الفعاليات",
  "fm.per_event.hint": "مبلغ ثابت لكل فعالية تنتهي بدون إلغاء، في أي مكان للشريك",
  "fm.monthly": "اشتراك شهري",
  "fm.monthly.hint": "مبلغ ثابت كل شهر من تاريخ بدء الاشتراك",
  "fm.none": "بدون نموذج",
  "b7.note.per_booking": "رسوم حجز حاضر",
  "b7.note.per_event": "رسوم فعالية منتهية",
  "b7.note.monthly": "اشتراك شهري",
  "ms.title": "ملخصات الشهر على واتساب",
  "ms.sub": "رسالة جاهزة لكل شريك بالرسوم والمدفوع والرصيد المستحق للشهر المحدد. اضغط لإرسالها.",
  "ms.empty": "لا يوجد شركاء معتمدون بعد",
  "ms.due": "المستحق",
  "ms.send": "إرسال الملخص",
  "ms.resend": "إعادة الإرسال",
  "ms.sent": "أُرسل بواسطة {by} · {at}",
  "ms.msgHead": "هلا {name}، ملخص حسابك في منصة وين نروح لشهر {month}:",
  "ms.msgLine": "• صافي الرسوم: {fees}\n• المدفوع: {paid}\n• الرصيد المستحق بنهاية الشهر: {due}",
  "ms.msgNone": "لا توجد حركات مالية",
  "ms.msgFoot": "شكراً لشراكتك معنا.",
  "fc.title": "مقارنة نماذج الرسوم",
  "fc.sub": "اكتب سعراً لكل نموذج لترى كم كان سيدفع كل شريك حسب نشاطه في آخر 30 يوماً. الأخضر هو الأعلى عائداً للمنصة.",
  "fc.currency": "العملة",
  "fc.activity": "{b} حجز حاضر · {e} فعالية منتهية",
  "fc.current": "الحالي",
  "notif.new": "جديد",
  "notif.open": "فتح",
  "notif.more": "و{n} إشعارات أخرى",
  "notif.f.all": "الكل",
  "notif.f.unread": "غير المقروءة",
  "notif.noUnread": "لا توجد إشعارات غير مقروءة",
  "live.on": "مباشر",
  "live.updated": "تم التحديث",
  "live.hint": "البيانات تتحدّث تلقائياً كل 30 ثانية",
  "push.title": "إشعارات الهاتف",
  "push.enable": "تفعيل إشعارات الهاتف",
  "push.disable": "إيقاف على هذا الجهاز",
  "push.test": "إرسال إشعار تجريبي",
  "push.testSent": "تم إرسال إشعار تجريبي",
  "push.enabled": "تم تفعيل إشعارات الهاتف على هذا الجهاز",
  "push.denied": "الإشعارات محظورة — اسمح بها من إعدادات المتصفح",
  "push.compact": "فعّل إشعارات الهاتف حتى توصلك حتى لو التطبيق مسكّر",
  "push.st.on": "مفعّلة على هذا الجهاز — توصلك الإشعارات حتى لو التطبيق مسكّر.",
  "push.st.off": "غير مفعّلة على هذا الجهاز.",
  "push.st.denied": "محظورة من المتصفح. افتح إعدادات الموقع واسمح بالإشعارات.",
  "push.st.unsupported": "هذا المتصفح لا يدعم إشعارات الهاتف.",
  "push.st.ios-install": "على الآيفون: اضغط زر المشاركة ← «إضافة إلى الشاشة الرئيسية»، ثم افتح التطبيق من الأيقونة وفعّل الإشعارات.",
  "err.Phone notifications are not enabled on any device": "إشعارات الهاتف غير مفعّلة على أي جهاز",
  "err.Could not deliver to this device. Turn notifications off and on again": "تعذّر الوصول لهذا الجهاز. أوقف الإشعارات ثم فعّلها من جديد",
  "welcome.title": "أهلاً {name}!",
  "welcome.sub": "خطوة وحدة قبل ما تبدأ: اكتب اسمك الرسمي ورقم هاتفك حتى يعرفك الشريك عند الحجز.",
  "welcome.step": "إكمال الحساب",
  "inst.title": "أضف «وين نروح» للشاشة الرئيسية",
  "inst.sub": "افتحه بضغطة مثل أي تطبيق، وتوصلك إشعارات الحجز حتى لو كان مسكّراً.",
  "inst.install": "تثبيت التطبيق",
  "inst.ios1": "اضغط زر المشاركة أسفل سفاري",
  "inst.ios2": "اختر «إضافة إلى الشاشة الرئيسية»",
  "auth.username": "اسم المستخدم",
  "auth.usernameHint": "بالإنكليزي وبدون مسافات، ويجب أن يحتوي على حرف واحد ورقم واحد ورمز واحد على الأقل (مثل _ أو @ أو .). ستدخل به لاحقاً.",
  "auth.forgotWa": "نسيت كلمة المرور؟ راسل إدارة المنصة",
  "auth.forgotAdmin": "نسيت كلمة المرور؟ تواصل مع إدارة المنصة لتعيين كلمة جديدة.",
  "auth.forgotMsg": "هلا، نسيت كلمة مرور حساب الشريك في وين نروح. اسم المستخدم: ",
  "err.Invalid username or password": "اسم المستخدم أو كلمة المرور غير صحيحة",
  "err.This username is taken": "اسم المستخدم مستخدم، اختر اسماً آخر",
  "err.This phone number is used by another partner account": "رقم الهاتف مستخدم بحساب شريك آخر",
  "err.Username must contain at least one English letter, one number and one symbol, without spaces": "اسم المستخدم يجب أن يحتوي على حرف إنكليزي ورقم ورمز واحد على الأقل، وبدون مسافات",
  "reg.resetPw": "تعيين كلمة مرور",
  "reg.resetPwTitle": "تعيين كلمة مرور جديدة",
  "reg.resetPwUser": "الحساب",
  "reg.resetPwNew": "كلمة المرور الجديدة (8 أحرف على الأقل)",
  "reg.resetPwDone": "تم تعيين كلمة المرور. أرسلها للشريك على واتساب.",
  "reg.resetPwSend": "إرسال على واتساب",
  "reg.resetPwMsg": "هلا، تم تعيين كلمة مرور جديدة لحسابك في وين نروح.\nاسم المستخدم: {u}\nكلمة المرور: {p}\nننصح بتغييرها بعد الدخول.",
  "sec.username": "اسم المستخدم للدخول",
  "sec.copy": "نسخ",
  "sec.copied": "تم نسخ اسم المستخدم",
  "sec.title": "تغيير كلمة المرور",
  "sec.current": "كلمة المرور الحالية",
  "sec.new": "كلمة المرور الجديدة (8 أحرف على الأقل)",
  "sec.confirm": "تأكيد كلمة المرور الجديدة",
  "sec.save": "حفظ كلمة المرور",
  "sec.changed": "تم تغيير كلمة المرور",
  "sec.mismatch": "كلمتا المرور غير متطابقتين",
  "sec.tempNote": "كلمة مرورك الحالية مؤقتة من إدارة المنصة. ننصحك بتغييرها الآن.",
  "sec.tempBanner": "كلمة مرورك مؤقتة من إدارة المنصة — ننصحك بتغييرها.",
  "sec.changeNow": "غيّرها الآن",
  "err.Current password is incorrect": "كلمة المرور الحالية غير صحيحة",
  "err.Choose a password different from the current one": "اختر كلمة مرور مختلفة عن الحالية",
  "bd.locked": "لا يمكن تعديل بيانات الحجز بعد حفظها. التعديل يتم عن طريق إدارة المنصة فقط.",
  "bd.askChange": "اطلب التعديل على واتساب",
  "bd.changeMsg": "هلا، أريد تعديل بيانات الحجز في حسابي على وين نروح.\nالبريد: {email}\nالاسم الحالي: {name}\nالرقم الحالي: {phone}\nالبيانات الجديدة: ",
  "reg.editDetails": "تعديل بيانات الحجز",
  "err.Booking details can only be changed by the platform admin": "بيانات الحجز تُعدّل عن طريق إدارة المنصة فقط",
  "fm.free_trial": "اشتراك مجاني (تجريبي)",
  "fm.free_trial.hint": "بدون رسوم لعدد أيام محدد، وبعدها يتقيّد الحساب حتى تختار نموذج الدفع",
  "admin.trialDays": "مدة الاشتراك المجاني (بالأيام)",
  "admin.trialUntil": "ينتهي يوم {date}، ويصلك تنبيه قبلها بـ 3 أيام",
  "admin.trialEnds": "ينتهي {date}",
  "err.Enter the free trial length in days": "أدخل مدة الاشتراك المجاني بالأيام",
  "err.Enter the amount": "أدخل المبلغ",
  "err.You have an active booking. You can book again after check-in or cancelling it": "لديك حجز قائم لم يُسجَّل حضورك فيه بعد. تقدر تحجز فعالية ثانية بعد تسجيل حضورك أو إلغاء الحجز الحالي.",
  "share.waShort": "واتساب",
  "bookings.copyShort": "نسخ الرمز",
  "bookings.saveShort": "حفظ الصورة",
  "cal.short": "التقويم",
  "pc.title": "تواصل مع إدارة المنصة",
  "pc.sub": "عندك سؤال أو مشكلة؟ راسل مدير المنصة مباشرة على واتساب.",
  "pc.button": "واتساب مدير المنصة",
  "pc.msg": "هلا، أتواصل وياكم من تطبيق وين نروح.",
  "pc.adminTitle": "رقم واتساب مدير المنصة",
  "pc.adminNote": "يظهر زر للتواصل في إعدادات الزبائن والشركاء وزر عائم في الصفحة الرئيسية. اتركه فارغاً لإخفاء الأزرار.",
  "pc.saved": "تم حفظ الرقم",
  "b5.lastContact": "آخر تواصل: {by} · {when}",
  "b5.contactTimes": "{n} مرات",
  "wat.title": "رسائل واتساب الجاهزة",
  "wat.hint": "تظهر عند الضغط على «واتساب الزبون» في بطاقة الحجز. استخدم {name} للاسم، {event} للفعالية، {date} للتاريخ، {guests} لعدد الأشخاص.",
  "wat.name": "اسم الرسالة",
  "wat.add": "رسالة جديدة",
  "wat.delete": "حذف",
  "wat.save": "حفظ الرسائل",
  "wat.saved": "تم حفظ الرسائل",
  "b5.cancelTitle": "إلغاء الحجز",
  "b5.lateWarn": "موعد الإلغاء المجاني انتهى ({time}). الإلغاء هسه يتحوّل للمراجعة",
  "b5.cancelUntil": "تكدر تلغي لحد {time}",
  "b5.keep": "رجوع",
  "b5.send": "إرسال",
  "b5.change": "تغيير العدد",
  "b5.changeTitle": "تغيير عدد الأشخاص",
  "b5.changeNote": "التغيير على حجز مؤكد يحتاج موافقة المكان. سعر الشخص يبقى نفس سعر وقت الحجز",
  "b5.newTotal": "الإجمالي الجديد",
  "b5.changePending": "طلب تغيير إلى {n} أشخاص بانتظار المكان",
  "b5.changeRejected": "انرفض طلب التغيير: {r}",
  "b5.changeSent": "انرسل طلب التغيير",
  "b5.changed": "تم تحديث العدد",
  "b5.material": "صار تغيير مهم على الفعالية ({f}). توافق أو تلغي بدون غرامة؟",
  "b5.accept": "موافق",
  "b5.declineCancel": "إلغاء بدون غرامة",
  "mf.start_at": "الموعد",
  "mf.end_at": "وقت الانتهاء",
  "mf.address": "العنوان",
  "mf.maps_url": "الموقع",
  "mf.programs": "البرنامج",
  "mf.terms": "الشروط",
  "mf.requirements": "المتطلبات",
  "b5.late": "إلغاء متأخر — قيد المراجعة",
  "b5.byVenue": "ألغاه المكان",
  "b5.eventCancelled": "انلغت الفعالية",
  "b5.tabRequests": "الطلبات الجديدة",
  "b5.tabConfirmed": "المؤكدة",
  "b5.tabAll": "الكل",
  "b5.allEvents": "كل الفعاليات",
  "b5.external": "حجز خارجي",
  "b5.externalTitle": "إضافة حجز خارجي",
  "b5.externalNote": "للحجوزات اللي وصلتك بالهاتف أو مباشرة. ما عليها رسوم منصة",
  "b5.name": "الاسم",
  "b5.phone": "الهاتف",
  "b5.note": "ملاحظة",
  "b5.added": "تمت الإضافة",
  "b5.sourceExternal": "خارجي",
  "b5.timeLeft": "باقي {m} دقيقة",
  "b5.approveChange": "موافقة",
  "b5.rejectChange": "رفض التغيير",
  "b5.changeReq": "يطلب تغيير العدد: {a} ← {b}",
  "b5.confirmed": "تم تأكيد الطلب",
  "b5.done": "تم",
  "b5.cancelEvent": "إلغاء الفعالية",
  "b5.cancelEventNote": "راح تنلغي كل الطلبات والحجوزات وينبلّغ الزبائن، وما عليهم أي غرامة",
  "b5.requestHint": "هذا طلب حجز — المكان راح يتواصل وياك ويأكد قبل انتهاء المهلة",
  "b5.notConfirmed": "الحجز مو مؤكد",
  "edit.areaEn": "المنطقة (إنكليزي)",
  "b5.pendingCount": "{n} طلب بانتظارك",
  "b5.empty": "ما فيه حجوزات هنا",
  "b6.booked": "المحجوز",
  "b6.arrived": "وصلوا",
  "b6.remaining": "الباقي",
  "b6.arrivingNow": "عدد الواصلين هسه",
  "b6.record": "سجّل {n} وصول",
  "b6.recorded": "انحفظ وصول {n} — المجموع {a} من {g}",
  "b6.allArrived": "وصل الكل",
  "b6.saving": "جاري الحفظ على الخادم…",
  "b6.delayed": "إدخال متأخر (بعد انقطاع)",
  "b6.delayedNote": "استخدمه بس إذا انقطع الإنترنت وسجّلت الوصول على ورق. اكتب وقت الوصول الحقيقي والسبب.",
  "b6.arrivedAt": "وقت الوصول الحقيقي",
  "b6.delayReason": "سبب الإدخال المتأخر",
  "b6.history": "سجل الحضور",
  "b6.late": "متأخر",
  "b6.checkName": "تأكد من اسم الحجز قبل الدخول — مشاركة الرمز ما تثبت الهوية",
  "b6.attendedOf": "حضر {a} من {g}",
  "b6.restrictedTitle": "الحجز موقوف مؤقتاً",
  "b6.restrictedMsg": "عندك حالة عدم حضور تحتاج مراجعة إدارة المنصة. رجاءً قدّم طلب توضّح بيه أسباب غيابك حتى ترجع صلاحية الحجز.",
  "b6.requestPh": "اشرح سبب غيابك بوضوح (10 أحرف على الأقل)",
  "b6.sendRequest": "إرسال الطلب للإدارة",
  "b6.requestSent": "انرسل طلبك، الإدارة راح تراجعه",
  "b6.awaiting": "طلبك وصل للإدارة وبانتظار القرار. الإيقاف يبقى لحد قرار الإدارة.",
  "b6.dispute": "اعتراض",
  "b6.disputeTitle": "اعتراض على سجل الحضور",
  "b6.disputeSent": "انرسل اعتراضك للإدارة",
  "b6.cases": "الحالات والطلبات",
  "b6.kind.no_show": "عدم حضور",
  "b6.kind.dispute": "اعتراض",
  "b6.cs.open": "مفتوحة",
  "b6.cs.awaiting_admin": "بانتظار قرار",
  "b6.cs.approved": "مقبولة",
  "b6.cs.rejected": "مرفوضة",
  "b6.approve": "قبول وإعادة الصلاحية",
  "b6.rejectCase": "رفض",
  "b6.decisionReason": "سبب القرار",
  "b6.decided": "تم تسجيل القرار",
  "b6.from.customer": "الزبون",
  "b6.from.venue": "المكان",
  "b6.noMessages": "الزبون ما قدّم طلب بعد",
  "b6.activeTab": "النشطة",
  "b6.closedTab": "المغلقة",
  "b6.reversed": "سجّل المكان دخول متأخر بعد الحالة",
  "b6.restrictedUser": "الحساب موقوف",
  "b6.decision": "القرار",
  "b6.newRequest": "طلب حجز جديد!",
  "b6.expiring": "{n} طلب تنتهي مهلته خلال دقائق",
  "b6.expiringOne": "{name} — باقي {m} دقيقة",
  "b6.review": "راجع الطلبات",
  "b6.soundOn": "الصوت مفعّل",
  "b6.soundOff": "الصوت مطفي",
  "err.You have a no-show case that requires review by platform administration. Please submit a request explaining the reasons for your absence to restore booking access.": "عندك حالة عدم حضور تحتاج مراجعة إدارة المنصة. رجاءً قدّم طلب توضّح بيه أسباب غيابك حتى ترجع صلاحية الحجز.",
  "err.Everyone on this booking has already arrived": "كل أشخاص هذا الحجز وصلوا",
  "err.Give the reason for the delayed entry": "اكتب سبب الإدخال المتأخر",
  "err.The arrival time must be during the event": "وقت الوصول لازم يكون خلال وقت الفعالية",
  "err.The delayed-entry window has closed": "انتهت مدة الإدخال المتأخر",
  "err.Use delayed entry with the actual arrival time and reason": "استخدم الإدخال المتأخر مع وقت الوصول الحقيقي والسبب",
  "err.The event has ended — use delayed entry": "الفعالية خلصت — استخدم الإدخال المتأخر",
  "err.It's too early to record attendance for this event": "بعده وكت مبكر لتسجيل الحضور",
  "err.This booking isn't confirmed": "الحجز مو مؤكد",
  "err.The confirmation deadline has passed": "انتهت مهلة التأكيد",
  "err.This request is no longer pending": "الطلب ما عاد معلّق",
  "err.You already have a pending request for this event": "عندك طلب معلّق لهذي الفعالية",
  "err.Changes are closed for this booking": "انتهى وقت التعديل على هذا الحجز",
  "err.This booking was updated. Refresh and try again": "الحجز تحدّث، حدّث الصفحة وحاول مرة ثانية",
  "err.Only attendance or no-show records can be disputed": "تكدر تعترض بس على سجلات الحضور أو عدم الحضور",
  "err.This case was already decided": "هذي الحالة انحسمت قبل",
  "err.This case is already closed": "هذي الحالة مغلقة",
  "nav.dashboard": "الرئيسية",
  "nav.finance": "الحسابات",
  "nav.audit": "سجل التدقيق",
  "b7.dashTitle": "لوحة الإدارة",
  "b7.dashSub": "نظرة سريعة على المنصة اليوم",
  "b7.venuesPending": "أماكن عامة بانتظار الموافقة",
  "b7.venuesApproved": "أماكن عامة معتمدة",
  "b7.venuesSuspended": "أماكن عامة موقوفة",
  "b7.bkPending": "طلبات بانتظار التأكيد",
  "b7.bkToday": "حجوزات اليوم",
  "b7.attendedToday": "حضروا اليوم",
  "b7.noShowToday": "لم يحضروا اليوم",
  "b7.openCases": "حالات مفتوحة",
  "b7.restricted": "حسابات موقوفة عن الحجز",
  "b7.notifFailures": "إشعارات فشل إرسالها",
  "b7.outstanding": "المستحق غير المدفوع",
  "b7.collected": "المحصّل",
  "b7.waived": "المعفى",
  "b7.feesDue": "رسوم مستحقة",
  "b7.recentAudit": "آخر العمليات",
  "b7.financeTitle": "الحسابات المالية",
  "b7.financeSub": "رسوم المنصة لكل مكان — كل عملة بحسابها، بدون تحويل",
  "b7.balance": "الرصيد",
  "b7.noEntries": "ماكو قيود بهذي الفترة",
  "b7.opening": "الرصيد الافتتاحي",
  "b7.fees": "رسوم مستحقة",
  "b7.debit_adj": "تسويات مدينة",
  "b7.exemptions": "إعفاءات معتمدة",
  "b7.credit_adj": "تسويات دائنة",
  "b7.payments": "دفعات",
  "b7.closing": "الرصيد الختامي",
  "b7.formula": "الافتتاحي + الرسوم + التسويات المدينة − الإعفاءات − التسويات الدائنة − الدفعات = الختامي",
  "b7.from": "من",
  "b7.to": "إلى",
  "b7.apply": "عرض",
  "b7.kind.fee": "رسم",
  "b7.kind.exemption": "إعفاء",
  "b7.kind.debit_adj": "تسوية مدينة",
  "b7.kind.credit_adj": "تسوية دائنة",
  "b7.kind.payment": "دفعة",
  "b7.note.launch_exemption": "إعفاء فترة الإطلاق",
  "b7.note.exempt": "إعفاء المكان",
  "b7.reversed": "معكوس",
  "b7.reversal": "عكس قيد",
  "b7.reverse": "عكس",
  "b7.reverseTitle": "عكس هذا القيد",
  "b7.addPayment": "تسجيل دفعة",
  "b7.addAdjust": "تسوية",
  "b7.kindLabel": "النوع",
  "b7.currency": "العملة",
  "b7.amount": "المبلغ",
  "b7.reason": "السبب / الملاحظة",
  "b7.method": "طريقة الدفع",
  "b7.reference": "رقم المرجع",
  "b7.date": "التاريخ",
  "b7.bookingRef": "رقم الحجز (اختياري)",
  "b7.otherCurrency": "دُفعت بعملة ثانية",
  "b7.settleCurrency": "عملة الدفع الفعلية",
  "b7.settleAmount": "المبلغ المدفوع فعلاً",
  "b7.rate": "سعر الصرف",
  "b7.direction": "اتجاه السعر (مثلاً 1 USD = ... IQD)",
  "b7.approvedBy": "موافقة",
  "b7.save": "حفظ القيد",
  "b7.saved": "انحفظ القيد",
  "b7.settled": "سُدّد بـ",
  "b7.myFinance": "رسوم المنصة",
  "b7.myFinanceSub": "الرسوم حسب النموذج المحدد لك: لكل حجز حاضر، أو لكل فعالية منتهية (بعد 48 ساعة من نهايتها)، أو اشتراك شهري.",
  "b7.feeRule": "رسوم المنصة",
  "b7.since": "من تاريخ",
  "b7.exemptRule": "معفى",
  "b7.launchUntil": "إعفاء الإطلاق ساري حتى",
  "b7.noRule": "ما محدد رسم بعد",
  "b7.launchTitle": "إعفاء فترة الإطلاق",
  "b7.launchNote": "الحجوزات والفعاليات وأشهر الاشتراك قبل هذا التاريخ رسومها صفر. التغيير يطبّق على الجديد بس.",
  "b7.endDate": "آخر يوم للإعفاء",
  "b7.launchSaved": "انحفظ تاريخ الإعفاء",
  "b7.history": "السجل",
  "b7.auditTitle": "سجل التدقيق",
  "b7.auditSub": "كل العمليات الحساسة: من سواها ومتى",
  "b7.todayList": "حجوزات اليوم",
  "b7.todayEmpty": "ماكو حجوزات مؤكدة اليوم",
  "b7.open": "فتح",
  "b7.checkBy": "سجّل وصولك قبل {t} حتى ما ينحسب عدم حضور",
  "b7.accounts": "الأماكن",
  "b7.total": "المجموع",
  "b7.pickAccount": "اختار مكان حتى تشوف كشف الحساب",
  "b8.balanceTitle": "تذكير ودّي برسوم المنصة",
  "b8.balanceBody": "رصيد رسوم المنصة المستحق وصل:",
  "b8.viewStatement": "عرض كشف الحساب",
  "b8.reminderTitle": "تذكير الرصيد المستحق",
  "b8.reminderNote": "لما يوصل رصيد المكان المستحق هذا المبلغ أو أكثر، يطلع لصاحب المكان شريط تذكير. اتركه فارغ حتى توقف التذكير لهذي العملة.",
  "b8.off": "متوقف",
  "b8.reminderSaved": "انحفظ حد التذكير",
  "b8.pdfTitle": "كشف حساب رسوم المنصة",
  "b8.details": "التفاصيل",
  "b8.generated": "تاريخ الإصدار",
  "b8.month": "الشهر",
  "b8.downloadPdf": "تنزيل PDF",
  "b8.pdfReady": "تنزّل كشف الحساب",
  "dp.pick": "اختر التاريخ",
  "dp.clear": "مسح",
  "dp.today": "اليوم",
  "dp.prev": "الشهر السابق",
  "dp.next": "الشهر الجاي",
  "dp.hour": "الساعة",
  "dp.minute": "الدقيقة",
  "dp.period": "صباحاً أو مساءً",
  "dp.required": "حدد تاريخ ووقت البداية والنهاية",
  "rc.receipt": "إيصال",
  "rc.no": "رقم الإيصال",
  "rc.venue": "المكان",
  "rc.by": "سجّلها",
  "rc.title": "إيصال دفعة رسوم المنصة",
  "rc.received": "استلمنا مبلغ",
  "rc.reversedNote": "هذي الدفعة انعكست لاحقاً",
  "rc.footer": "إيصال صادر من منصة وين نروح لدفعة رسوم المنصة. ما يعتبر فاتورة ضريبية.",
  "rc.download": "إيصال PDF",
  "rc.downloaded": "تنزّل الإيصال",
  "rc.failed": "ما كدرنا نسوي ملف الإيصال",
  "rc.resend": "إعادة الإرسال",
  "rc.saved": "انسجلت الدفعة وانرسل الإيصال للمكان",
  "rc.email.sent": "انرسل بالإيميل",
  "rc.email.sending": "جاري الإرسال",
  "rc.email.partial": "انرسل لبعض المستلمين",
  "rc.email.failed": "فشل الإرسال",
  "rc.email.no_recipients": "ما أكو إيميل للمكان",
  "et.sub": "أنت بس تحدد الأنواع. أصحاب الأماكن يختارون منها وما يكدرون يضيفون أو يعدلون.",
  "et.readOnly": "إدارة الأنواع للمدير العام فقط.",
  "et.edit": "تعديل النوع",
  "et.delete": "حذف النوع",
  "et.nameAr": "الاسم بالعربي",
  "et.nameEn": "الاسم بالإنكليزي",
  "et.slugHint": "حروف إنكليزية صغيرة و _ فقط، ما يتغير بعد الإنشاء",
  "et.slugLocked": "المعرّف ما يتغير بعد الإنشاء",
  "et.progLabelAr": "اسم قسم الفقرات (عربي)",
  "et.progLabelEn": "اسم قسم الفقرات (إنكليزي)",
  "et.editNote": "التعديل يطبق على الفعاليات الجديدة والتعديلات الجاية، والفعاليات المنشورة تبقى مثل ما هي.",
  "et.created": "انضاف النوع",
  "et.updated": "انحفظ النوع",
  "et.count": "{n} فعالية",
  "et.countFew": "{n} فعاليات",
  "et.inUse": "ما ينحذف لأن عليه فعاليات ({n}). تكدر توقفه بدل الحذف.",
  "et.confirmDelete": "تحذف نوع «{name}» نهائياً؟",
  "err.This type already exists": "هذا المعرّف موجود، اختار معرّف ثاني",
  "err.This type is used by events": "ما ينحذف لأن عليه فعاليات. تكدر توقفه بدل الحذف",
  "err.Type not found": "النوع مو موجود",
  "qr.button": "ملصق QR",
  "qr.eventButton": "ملصق QR",
  "qr.title": "ملصق QR للمكان",
  "qr.hint": "الكود يفتح صفحة المكان على وين نروح، حتى الزباين يشوفون فعالياتكم ويحجزون.",
  "qr.poster": "ملصق A4",
  "qr.posterSub": "للحايط أو الباب",
  "qr.cards": "بطاقات طاولة",
  "qr.cardsSub": "4 بطاقات بورقة A4 وحدة، تقصها على الخط",
  "qr.scan": "امسح الكود واحجز",
  "qr.scanSub": "شوف فعالياتنا الجاية واحجز مكانك من موبايلك",
  "qr.downloaded": "تنزّل الملف، اطبعه بالحجم الأصلي",
  "qr.failed": "ما كدرنا نسوي الملف",
  "qr.unpublished": "المكان مخفي، انشره حتى تطبع الملصق",
  "pinv.title": "رابط دعوة الشركاء",
  "pinv.sub": "أرسله لأي مكان تريده ينضم. يفتح صفحة التسجيل، والطلب يوصلك للموافقة.",
  "pinv.whatsapp": "إرسال بواتساب",
  "pinv.qr": "تنزيل كود QR",
  "pinv.msg": "هلا! ندعوك تنضم لمنصة وين نروح كشريك وتعرض فعالياتك للزباين بالعراق. سجّل من هنا:",
  "guide.title": "أهلاً بيك بوين نروح!",
  "guide.sub": "خطوات بسيطة وتصير فعاليتك الأولى قدام الزباين.",
  "guide.dismiss": "إخفاء الدليل",
  "guide.optional": "اختياري",
  "guide.logo": "ارفع شعارك",
  "guide.logoSub": "يطلع لما أحد يشارك رابط مكانك بواتساب",
  "guide.venue": "أضف مكانك",
  "guide.venueSub": "الاسم والعنوان والموقع على الخريطة",
  "guide.photos": "أضف صور للمكان",
  "guide.photosSub": "الصور الحلوة تجيب حجوزات أكثر",
  "guide.event": "انشر أول فعالية",
  "guide.eventSub": "حدد الموعد والسعر، وتطلع مباشرة بالاستكشاف",
  "guide.team": "أضف فريقك",
  "guide.teamSub": "موظف استقبال يأكد الطلبات ويسجل الحضور",
  "celebrate.title": "مبروك! أول فعالية إلك صارت منشورة",
  "celebrate.sub": "الزباين يكدرون يشوفونها ويحجزون هسه. شاركها حتى توصل لناس أكثر.",
  "celebrate.later": "بعدين",
  "fav.loginNeeded": "سجّل دخولك كعميل عشان تحفظ أماكنك المفضلة",
  "review.button": "قيّم تجربتك",
  "review.yours": "تقييمك",
  "review.title": "كيف كانت تجربتك؟",
  "review.sub": "تقييمك يساعد غيرك يختار طلعته الجاية",
  "review.comment": "اكتب رأيك (اختياري)",
  "review.submit": "إرسال التقييم",
  "review.saved": "شكراً! تم حفظ تقييمك",
  "review.section": "التقييمات",
  "review.none": "ما فيه تقييمات للحين. كن أول من يقيّم بعد زيارتك",
  "review.count": "تقييم",
  "review.new": "جديد",
  "invite.title": "{host} يدعوك للطلعة!",
  "invite.sub": "احجز مكانك في نفس اليوم وانضم للمجموعة",
  "invite.members": "في المجموعة",
  "invite.people": "أشخاص",
  "invite.join": "انضم واحجز",
  "invite.own": "هذي دعوتك أنت — شاركها مع أصدقائك",
  "invite.expired": "انتهت هذي الدعوة",
  "invite.notFound": "الدعوة غير موجودة",
  "invite.loginFirst": "سجّل وانضم للمجموعة",
  "invite.alreadyJoined": "أنت منضم لهذي المجموعة — تذكرتك في حجوزاتي",
  "invite.partnerNote": "الدعوات مخصصة لحسابات العملاء",
  "invite.joined": "انضممت للمجموعة! تذكرتك جاهزة",
  "invite.dateLocked": "تاريخ المجموعة",
  "group.chip": "مجموعة",
  "share.inviteText": "يلا نطلع سوا! 🎉 حجزت في {venue} يوم {date}. احجز معي وانضم للمجموعة:",
  "err.Invite not found": "الدعوة غير موجودة",
  "err.You can't join your own invite": "ما تقدر تنضم لدعوتك أنت",
  "err.This invite has expired": "انتهت هذي الدعوة",
  "err.You already joined this group": "أنت منضم لهذي المجموعة مسبقاً",
  "err.You can review after your visit": "تقدر تقيّم بعد ما تزور المكان",
  "type.evening": "سهرات",
  "type.horse_riding": "فروسية",
  "type.motorcycling": "دراجات نارية",
  "type.arts": "فنون وورش",
  "role.reception": "استقبال",
  "role.finance": "مالية",
  "role.super": "مدير عام",
  "auth.emailTab": "بالبريد",
  "auth.googleTab": "Google",
  "auth.or": "أو",
  "auth.loginTitle": "دخول بالبريد",
  "auth.signupTitle": "حساب جديد",
  "auth.signup": "إنشاء حساب",
  "auth.haveCustomer": "عندك حساب؟ سجّل دخولك",
  "auth.newCustomer": "جديد؟ أنشئ حساب",
  "auth.forgot": "نسيت كلمة المرور؟",
  "auth.pwHint": "8 أحرف على الأقل",
  "forgot.title": "نسيت كلمة المرور؟",
  "forgot.sub": "اكتب بريدك ونرسل لك رابط لتعيين كلمة مرور جديدة.",
  "forgot.send": "أرسل الرابط",
  "forgot.sent": "إذا كان البريد مسجّل عندنا، راح يوصلك رابط إعادة التعيين خلال دقائق.",
  "forgot.blocked": "تنبيه: خدمة البريد غير مفعّلة بعد (محجوبة) — الرابط يُسجَّل في سجل الخادم فقط حالياً.",
  "reset.title": "كلمة مرور جديدة",
  "reset.sub": "اختر كلمة مرور قوية لحسابك.",
  "reset.submit": "حفظ كلمة المرور",
  "reset.done": "تم تغيير كلمة المرور، سجّل دخولك الحين",
  "reset.missing": "الرابط ناقص أو غير صالح",
  "profile.bookingName": "الاسم في الحجوزات",
  "bd.title": "بيانات الحجز",
  "bd.sub": "اكتب اسمك الرسمي ورقم هاتفك. الحجز يكون باسمك الرسمي، والمكان يشوفه ويا الرقم عند التأكيد والاستقبال.",
  "bd.name": "الاسم الرسمي",
  "bd.namePh": "مثلاً: علي حسين كاظم",
  "bd.nameHint": "مثل ما مكتوب بالهوية، اسمين على الأقل.",
  "bd.needed": "قبل أول حجز، اكتب اسمك الرسمي ورقم هاتفك. الحجز يكون بهذا الاسم.",
  "bd.saved": "انحفظت بيانات الحجز",
  "bd.edit": "تعديل",
  "err.Enter your full official name (at least two names)": "اكتب اسمك الرسمي الكامل (اسمين على الأقل)",
  "err.Add your official name and phone number first": "اكتب اسمك الرسمي ورقم هاتفك أول",
  "profile.bookingNameHint": "هذا الاسم يظهر للمكان عند الاستقبال، وتقدر تغيّره بأي وقت.",
  "profile.saveName": "حفظ الاسم",
  "profile.nameSaved": "تم حفظ الاسم",
  "profile.signin": "طرق الدخول",
  "profile.google": "Google مرتبط",
  "profile.passwordSet": "كلمة مرور مفعّلة",
  "phone.title": "رقم الموبايل",
  "phone.sub": "لازم توثّق رقمك قبل ما ترسل أي طلب حجز.",
  "phone.placeholder": "07XX XXX XXXX",
  "phone.send": "أرسل رمز التحقق",
  "phone.resend": "إعادة الإرسال",
  "phone.code": "رمز التحقق (6 أرقام)",
  "phone.verify": "تحقق",
  "phone.verified": "رقمك موثّق",
  "phone.change": "تغيير الرقم",
  "phone.sent": "أرسلنا الرمز إلى",
  "phone.done": "تم توثيق رقمك",
  "phone.blocked": "خدمة الرسائل غير مفعّلة بعد (محجوبة). وضع تجريبي — الرمز:",
  "booking.phoneNeeded": "وثّق رقم موبايلك أولاً عشان تقدر ترسل طلب الحجز.",
  "booking.verifyNow": "وثّق رقمي الآن",
  "team.roleHint": "المالك: كل الصلاحيات · الاستقبال: الحجوزات وتسجيل الحضور · المالية: الحجوزات والملخصات المالية",
  "team.changeRole": "تغيير الدور",
  "team.roleChanged": "تم تغيير الدور",
  "admin.team": "فريق الإدارة",
  "admin.teamSub": "المدير العام: كل الصلاحيات · الاستقبال: متابعة الحجوزات والشركاء · المالية: الرسوم والحسابات",
  "admin.addMember": "إضافة عضو",
  "admin.superOnly": "الموافقة والرفض للمدير العام فقط",
  "settings.timezone": "المنطقة الزمنية",
  "settings.tzValue": "بغداد (Asia/Baghdad)",
  "err.Phone verification required": "وثّق رقم موبايلك أولاً قبل الحجز",
  "err.Enter a valid Iraqi mobile number": "أدخل رقم موبايل عراقي صحيح مثل 07XXXXXXXXX (11 رقماً)",
  "err.This phone number is used by another account": "هذا الرقم مستخدم بحساب آخر",
  "err.Customers sign in with Google only": "دخول الزبائن عبر Google فقط — ارجع لصفحة دخول الزبائن",
  "auth.googleOnly": "لا تحتاج بريداً أو كلمة مرور جديدة، حسابك في Google يكفي.",
  "err.Please wait a minute before requesting a new code": "انتظر دقيقة قبل طلب رمز جديد",
  "err.Incorrect code": "الرمز غير صحيح",
  "err.Code expired. Request a new one": "انتهت صلاحية الرمز، اطلب رمز جديد",
  "err.This phone number is already verified on another account": "هذا الرقم موثّق على حساب آخر",
  "err.Invalid or expired reset link": "الرابط غير صالح أو منتهي",
  "err.Your venue role does not allow this action": "دورك في المكان لا يسمح بهذا الإجراء",
  "err.Your admin role does not allow this action": "دورك في الإدارة لا يسمح بهذا الإجراء",
  "err.You can't change your own role": "ما تقدر تغيّر دورك بنفسك",
  "err.This email is linked to a different Google account": "هذا البريد مرتبط بحساب Google آخر",
  "err.The primary account owner can't be changed or removed": "ما يمكن تغيير أو حذف المالك الأساسي للحساب",
  "err.Session expired": "انتهت الجلسة، سجّل دخولك مرة ثانية",
  "err.Not authenticated": "انتهت الجلسة، سجّل دخولك مرة ثانية",
  "gov.baghdad": "بغداد",
  "gov.basra": "البصرة",
  "gov.nineveh": "نينوى",
  "gov.erbil": "أربيل",
  "gov.sulaymaniyah": "السليمانية",
  "gov.duhok": "دهوك",
  "gov.halabja": "حلبجة",
  "gov.kirkuk": "كركوك",
  "gov.anbar": "الأنبار",
  "gov.babil": "بابل",
  "gov.karbala": "كربلاء",
  "gov.najaf": "النجف",
  "gov.wasit": "واسط",
  "gov.diyala": "ديالى",
  "gov.saladin": "صلاح الدين",
  "gov.qadisiyyah": "القادسية",
  "gov.maysan": "ميسان",
  "gov.dhi_qar": "ذي قار",
  "gov.muthanna": "المثنى",
  "reg.manager": "اسم مدير الحساب",
  "reg.whatsapp": "رقم الواتساب",
  "reg.governorate": "المحافظة",
  "reg.area": "المنطقة",
  "reg.address": "العنوان المختصر",
  "reg.maps": "رابط Google Maps",
  "reg.logo": "شعار أو صورة المكان",
  "reg.description": "وصف قصير (اختياري)",
  "reg.chooseGov": "اختر المحافظة",
  "reg.logoHint": "JPG أو PNG أو WEBP أو HEIC بأي حجم — نضغطها تلقائياً",
  "reg.logoNeeded": "ارفع الشعار عشان نقدر نراجع طلبك",
  "reg.uploadLogo": "رفع الشعار",
  "reg.logoSaved": "تم حفظ الشعار",
  "status.suspended": "موقوف",
  "suspended.title": "حسابك موقوف مؤقتاً",
  "suspended.body": "ما تقدر تنشر أو تستقبل طلبات جديدة حالياً. حجوزاتك الحالية محفوظة وتقدر تطّلع عليها.",
  "status.reason": "السبب",
  "admin.suspend": "إيقاف",
  "admin.reactivate": "إعادة التفعيل",
  "admin.reason": "السبب",
  "admin.reasonRequired": "اكتب السبب (إلزامي)",
  "admin.history": "سجل القرارات",
  "admin.fee": "نموذج رسوم المنصة",
  "admin.feeAmount": "المبلغ",
  "admin.currency": "العملة",
  "admin.effective": "تاريخ السريان",
  "admin.exempt": "إعفاء من الرسوم",
  "admin.exemptReason": "سبب الإعفاء",
  "admin.exemptDays": "مدة الإعفاء بالأيام (اختياري)",
  "admin.exemptUntil": "معفى من الرسوم لحد {date}",
  "admin.exemptForever": "معفى من الرسوم بدون مدة محددة",
  "admin.exemptEnded": "انتهى الإعفاء بتاريخ {date}",
  "admin.feeHint": "اختر نموذجاً واحداً للشريك. يبدأ تطبيقه من لحظة الحفظ.",
  "admin.feeCurrent": "الرسوم الحالية",
  "admin.noFee": "بدون رسوم",
  "admin.changeFee": "تعديل الرسوم",
  "admin.feeSaved": "تم حفظ الرسوم",
  "admin.done": "تم تنفيذ الإجراء",
  "admin.maps": "الموقع على الخريطة",
  "admin.manager": "المدير",
  "err.Enter a valid Google Maps link": "أدخل رابط Google Maps صحيح",
  "err.Choose a valid governorate": "اختر محافظة صحيحة",
  "err.Fee settings are required to approve": "حدد رسوم المنصة قبل الموافقة",
  "err.A reason is required": "السبب مطلوب",
  "err.An exemption reason is required": "سبب الإعفاء مطلوب",
  "err.Venue account suspended": "حساب المكان موقوف",
  "err.This venue is not accepting requests": "هذا المكان لا يستقبل طلبات حالياً",
  "err.IQD amounts must be whole numbers": "مبالغ الدينار أرقام صحيحة فقط",
  "err.USD amounts allow at most 2 decimals": "الدولار يقبل منزلتين عشريتين كحد أقصى",
  "err.Image can't be reduced below 200 KB with acceptable quality": "ما قدرنا نصغّر الصورة لأقل من 200KB بجودة مقبولة",
  "err.On approval the fee must be effective today or earlier": "عند الموافقة لازم يكون تاريخ سريان الرسوم اليوم أو قبله",
  "nav.events": "الفعاليات",
  "ev.openBadge": "مفتوح للطلبات",
  "ev.closedBadge": "الطلبات مغلقة",
  "ev.endedBadge": "انتهت",
  "ev.cancelledBadge": "ملغاة",
  "ev.free": "مجاني",
  "ev.from": "من",
  "ev.perPerson": "للشخص",
  "ev.endsNextDay": "تنتهي اليوم التالي",
  "ev.details": "التفاصيل",
  "ev.request": "أرسل طلب حجز",
  "ev.schedule": "الموعد",
  "ev.includes": "السعر يشمل",
  "ev.separately": "يُدفع بشكل منفصل",
  "ev.requirements": "شروط المشاركة",
  "ev.terms": "الشروط والأحكام",
  "ev.cancelPolicy": "الإلغاء متاح حتى",
  "ev.options": "خيارات الحجز",
  "ev.location": "الموقع",
  "ev.directions": "الاتجاهات",
  "ev.empty": "ما فيه فعاليات تطابق بحثك حالياً",
  "ev.title": "اكتشف الفعاليات",
  "ev.today": "اليوم",
  "ev.anyDate": "أي تاريخ",
  "ev.allGov": "كل المحافظات",
  "ev.upcoming": "فعاليات قادمة",
  "ev.noUpcoming": "ما فيه فعاليات قادمة لهذا المكان",
  "ev.viewEvents": "شوف الفعاليات",
  "ev.priceLabel": "السعر",
  "ev.pricing.free": "دخول مجاني",
  "ev.pricing.paid": "دخول مدفوع",
  "ev.pricing.free_meal_optional": "دخول مجاني بدون وجبة إلزامية",
  "ev.pricing.paid_no_meal": "دخول مدفوع بدون وجبة",
  "ev.pricing.free_meal_required": "دخول مجاني بشرط طلب وجبة",
  "ev.pricing.paid_with_meal": "دخول مدفوع يشمل وجبة",
  "aud.youth": "شباب",
  "aud.family": "عائلات",
  "cat.standard": "عادي",
  "cat.vip": "VIP",
  "prog.singer": "مطرب",
  "prog.band": "فرقة",
  "prog.dj": "DJ",
  "prog.training": "تدريب",
  "prog.tour": "جولة",
  "prog.workshop": "ورشة",
  "prog.art_display": "عرض فني",
  "bk.option": "اختر الخيار",
  "bk.people": "عدد الأشخاص",
  "bk.total": "الإجمالي",
  "bk.review": "راجع السعر والشروط قبل الإرسال",
  "bk.sent": "وصل طلبك! بانتظار تأكيد المكان",
  "ve.title": "فعالياتي",
  "ve.sub": "أنشئ فعاليات بمواعيد وأسعار، وافتح أو أغلق الطلبات بأي وقت",
  "ve.new": "فعالية جديدة",
  "ve.edit": "تعديل",
  "ve.copy": "نسخ لتاريخ جديد",
  "ve.copyTitle": "نسخ الفعالية",
  "ve.copyFrom": "نسخة من «{title}»",
  "ve.copyHint": "عبّينا كل التفاصيل والصورة، وحطينا نفس اليوم والوقت بعد أسبوع. غيّر البداية إذا تحتاج (النهاية تتحرك وياها) وراجع وبعدين احفظ.",
  "ve.copyDates": "اختر التواريخ",
  "ve.copied": "تم إنشاء النسخ",
  "ve.open": "فتح الطلبات",
  "ve.close": "إغلاق الطلبات",
  "ve.saved": "تم حفظ الفعالية",
  "ve.hiddenByAdmin": "مخفية من الإدارة",
  "ve.f.venue": "المكان",
  "ve.f.type": "نوع الفعالية",
  "ve.f.titleAr": "اسم الفعالية (عربي)",
  "ve.f.titleEn": "اسم الفعالية (إنجليزي)",
  "ve.f.poster": "البوستر",
  "ve.f.shortAr": "وصف قصير",
  "ve.f.details": "التفاصيل",
  "ve.f.start": "البداية",
  "ve.f.end": "النهاية",
  "ve.f.pricing": "نموذج السعر",
  "ve.f.price": "السعر للشخص",
  "ve.f.addOption": "إضافة خيار",
  "ve.f.audience": "الفئة",
  "ve.f.category": "الدرجة",
  "ve.f.none": "—",
  "ve.f.addProgram": "إضافة فقرة",
  "ve.f.programName": "اسم الفقرة",
  "ve.f.programTime": "الوقت (اختياري)",
  "ve.f.confirm": "مهلة التأكيد (دقيقة)",
  "ve.f.grace": "فترة السماح للوصول (دقيقة)",
  "ve.f.cancelCut": "آخر موعد للإلغاء قبل نهاية السماح (دقيقة، اختياري)",
  "ve.f.maps": "رابط Google Maps (افتراضياً موقع المكان)",
  "ve.f.address": "العنوان",
  "ve.f.uploadPoster": "رفع البوستر",
  "ae.title": "الفعاليات وأنواعها",
  "ae.types": "أنواع الفعاليات",
  "ae.active": "مفعّل",
  "ae.inactive": "غير مفعّل",
  "ae.options": "خيارات فئة/درجة",
  "ae.meals": "وجبات",
  "ae.programs": "أنواع الفقرات",
  "ae.hide": "إخفاء",
  "ae.unhide": "إظهار",
  "ae.hidden": "مخفية",
  "ae.events": "كل الفعاليات",
  "ae.newType": "نوع جديد",
  "ae.slug": "المعرّف (إنجليزي)",
  "err.This event is not accepting requests": "هذه الفعالية لا تستقبل طلبات حالياً",
  "err.Choose a booking option": "اختر خيار الحجز",
  "err.Meal options are not available for this event type": "خيارات الوجبات غير متاحة لهذا النوع",
  "err.Booking options are not available for this event type": "خيارات الفئة والدرجة غير متاحة لهذا النوع",
  "err.Invalid program type for this event": "نوع الفقرة غير مناسب لهذا النوع",
  "err.The end time must be after the start time": "النهاية لازم تكون بعد البداية",
  "err.Requests must close before the event ends": "وقت إغلاق الطلبات لازم يكون قبل نهاية الفعالية",
  "err.The requests closing time must be in the future": "وقت إغلاق الطلبات لازم يكون بالمستقبل",
  "err.Enter a valid WhatsApp number": "اكتب رقم واتساب صحيح",
  "err.Set the per-person price and currency": "حدد السعر للشخص والعملة",
  "err.Choose free or paid entry": "اختار دخول مجاني أو دخول مدفوع",
  "err.Booking options and programs are no longer available": "الخيارات والفقرات ما عادت متوفرة",
  "err.Free events can't have a price": "الفعالية المجانية ما يكون لها سعر",
  "err.The arrival cutoff can't be after the event end": "نهاية السماح لا يمكن أن تتجاوز نهاية الفعالية",
  "err.Requests can't be reopened for this event": "لا يمكن إعادة فتح الطلبات لهذه الفعالية",
  "err.Choose an active event type": "اختر نوع فعالية مفعّل",
  "err.Copies must be in the future": "النسخ لازم تكون بتواريخ قادمة",
  "ve.f.conditions": "شروط الخيار (اختياري)",
  "err.Hidden events can't be copied": "لا يمكن نسخ فعالية مخفية",
  "err.Invalid date": "تاريخ غير صالح",
  "lang.switch": "English",
  "err.Invalid email or password": "البريد أو كلمة المرور غير صحيحة",
  "err.Email already registered": "البريد مسجل مسبقاً",
  "err.Too many attempts. Try again later": "محاولات كثيرة، حاول بعد شوي",
  "err.This email belongs to a venue/admin account": "هذا البريد مرتبط بحساب شريك أو إدارة",
  "err.Owner only": "هذه الصلاحية للمالك فقط",
  "nav.spots": "أماكن عامة",
  "spot.title": "أماكن عامة",
  "spot.sub": "مطاعم ومنتجعات وحدائق وكل مكان عام يستاهل الزيارة",
  "spot.empty": "ما فيه أماكن عامة هنا حالياً",
  "spot.legendSpot": "مكان عام",
  "spot.legendVenue": "مكان بحجز",
  "spot.cat.park": "حديقة",
  "spot.cat.corniche": "كورنيش",
  "spot.cat.square": "ساحة",
  "spot.cat.heritage": "معلم تراثي",
  "spot.cat.lake": "بحيرة ومتنزه مائي",
  "spot.cat.other": "أخرى",
  "spot.noBooking": "هذا مكان عام مفتوح للجميع، ما يحتاج حجز.",
  "spot.directions": "الاتجاهات",
  "spot.shareMsg": "شوف هذا المكان على وين نروح: {name}",
  "spot.adminTitle": "الأماكن العامة",
  "spot.adminSub": "أماكن مفتوحة للزوار بدون حجز",
  "spot.adminEmpty": "ما أضفت أماكن عامة بعد",
  "spot.add": "إضافة مكان عام",
  "spot.edit": "تعديل المكان العام",
  "spot.confirmDelete": "تحذف «{name}» نهائياً؟",
  "spot.deleted": "انحذف المكان",
  "spot.saved": "انحفظ المكان",
  "spot.hidden": "مخفي",
  "spot.nameAr": "الاسم بالعربي",
  "spot.nameEn": "الاسم بالإنجليزي (اختياري)",
  "spot.category": "التصنيف",
  "spot.governorate": "المحافظة",
  "spot.area": "المنطقة",
  "spot.address": "العنوان",
  "spot.hours": "أوقات الفتح (مثلاً: يومياً 8 صباحاً - 12 ليلاً)",
  "spot.description": "الوصف",
  "spot.photos": "الصور",
  "spot.location": "الموقع على الخريطة",
  "spot.pickHint": "اضغط على الخريطة لتحديد الموقع",
  "spot.visible": "ظاهر للزبائن",
  "spot.save": "حفظ",
  "spot.errName": "اكتب اسم المكان",
  "spot.errLocation": "حدد الموقع على الخريطة",
  "fav.tabSpots": "أماكن عامة",
  "fav.emptySpots": "ما حفظت أي مكان عام بعد",
  "fav.loginNeededSpot": "سجّل دخولك حتى تحفظ الأماكن العامة",
  "spot.km": "{n} كم",
  "spot.nearMe": "قريب مني",
  "spot.noGeo": "جهازك ما يدعم تحديد الموقع",
  "spot.geoDenied": "ما قدرنا نحدد موقعك، اسمح بالوصول للموقع وحاول مرة ثانية",
  "spot.featured": "أماكن عامة مميزة",
  "spot.featuredSub": "الأعلى تقييماً والأكثر حفظاً عند الزوار",
  "spot.seeAll": "عرض الكل",
  "spot.tabSpots": "الأماكن العامة",
  "spot.tabReviews": "التقييمات",
  "rev.title": "تقييمات ونصائح الزوار",
  "rev.count": "{n} تقييم",
  "rev.empty": "ما فيه تقييمات بعد، كن أول من يقيّم",
  "rev.login": "سجّل دخولك حتى تقيّم",
  "rev.ask": "شلون كانت زيارتك؟",
  "rev.tipPh": "نصيحة قصيرة للزوار (اختياري) — مثلاً: أحلى وقت للزيارة العصر",
  "rev.moderated": "يظهر تقييمك بعد مراجعة الإدارة",
  "rev.send": "إرسال",
  "rev.sent": "وصل تقييمك، راح يظهر بعد المراجعة",
  "rev.pickStars": "اختار عدد النجوم",
  "rev.mine": "تقييمك",
  "rev.edit": "تعديل تقييمي",
  "rev.reason": "السبب",
  "rev.status.pending": "بانتظار المراجعة",
  "rev.status.approved": "منشور",
  "rev.status.rejected": "مرفوض",
  "rev.adminEmpty": "ما فيه تقييمات هنا",
  "rev.rejectPrompt": "سبب الرفض (اختياري)",
  "rev.confirmDelete": "تحذف هذا التقييم نهائياً؟",
  "rev.approve": "موافقة",
  "rev.reject": "رفض",
  "rev.done.approve": "انتشر التقييم",
  "rev.done.reject": "انرفض التقييم",
  "rev.done.delete": "انحذف التقييم",
  "nav.reviews": "التقييمات",
  "er.title": "تقييمات الحضور",
  "er.venueTitle": "تقييمات فعاليات هذا المكان",
  "er.empty": "ما فيه تقييمات بعد",
  "er.rate": "قيّم الفعالية",
  "er.yourRating": "تقييمك {n}/5",
  "er.dialogTitle": "شلون كانت الفعالية؟",
  "er.commentPh": "اكتب رأيك بالفعالية (اختياري)",
  "er.thanks": "شكراً، انحفظ تقييمك",
  "er.partnerTitle": "تقييمات فعالياتي",
  "er.partnerSub": "آراء الزبائن اللي حضروا فعالياتك",
  "er.partnerEmpty": "ما وصلتك تقييمات بعد. الزبائن يقدرون يقيّمون بعد ما يتسجل حضورهم",
  "er.adminTitle": "تقييمات الفعاليات",
  "sug.cta": "تعرف مكان عام حلو؟ اقترحه علينا",
  "sug.title": "اقتراح مكان عام",
  "sug.hint": "راح تراجع الإدارة اقتراحك، وإذا انقبل ينضاف للأماكن العامة وتوصلك إشعار.",
  "sug.send": "إرسال الاقتراح",
  "sug.sent": "وصل اقتراحك، شكراً لك",
  "sug.mine": "اقتراحاتي ({n})",
  "sug.status.pending": "بانتظار المراجعة",
  "sug.status.approved": "مقبول",
  "sug.status.rejected": "مرفوض",
  "sug.tab": "اقتراحات الزبائن",
  "sug.adminEmpty": "ما فيه اقتراحات هنا",
  "sug.by": "اقترحه",
  "sug.approved": "انقبل الاقتراح وانضاف المكان",
  "sug.rejected": "انرفض الاقتراح",
  "seat.title": "أنواع الحجز المتوفرة",
  "seat.hint": "اختار الأنواع اللي تناسب فعاليتك، والزبون يختار واحد منها عند الحجز. تقدر تفعّلها كلها.",
  "seat.general": "عادي",
  "seat.vip": "VIP",
  "seat.family": "عائلي",
  "seat.youth": "شباب",
  "seat.ladies": "سيدات",
  "seat.all": "تفعيل الكل",
  "seat.none": "إلغاء الكل",
  "seat.vipFee": "أجور VIP الإضافية",
  "seat.perPerson": "للفرد",
  "seat.perBooking": "للحجز كامل",
  "seat.vipHint": "تنضاف على سعر الفعالية عند اختيار الزبون VIP. اتركها فارغة إذا ما فيه أجور.",
  "seat.choose": "اختار نوع الحجز",
  "seat.type": "نوع الحجز",
  "seat.available": "أنواع الحجز",
  "top.label": "الأعلى تقييماً",
  "top.tip": "مكان هذه الفعالية حاصل على {avg} من 5 من {n} تقييم",
  "img.title": "حجم الصور المرفوعة",
  "img.note": "كل صورة تنرفع (صور الأماكن، البوسترات، الأماكن العامة والاقتراحات) تصغر وتنضغط تلقائياً لهذا الحد مع الحفاظ على أفضل جودة ممكنة. تقبل JPG وPNG وWEBP وHEIC حتى 40 ميغابايت.",
  "img.maxKb": "الحد الأقصى للحجم (كيلوبايت)",
  "img.maxSide": "أقصى طول للضلع (بكسل)",
  "img.saved": "انحفظت حدود الصور، وتنطبق على الصور الجديدة",
  "img.stats": "الصور المخزنة: {n} · الحجم الكلي {mb} ميغابايت · فوق الحد الحالي: {over}",
  "img.recompress": "اضغط الصور الموجودة للحد الحالي",
  "img.running": "جاري ضغط الصور…",
  "img.confirm": "راح نضغط كل الصور المخزنة اللي أكبر من {kb} كيلوبايت. نكمل؟",
  "img.started": "بدأ ضغط الصور الموجودة",
  "img.progress": "تمت معالجة {done} من {total} · انضغطت {changed} صورة · وفّرنا {mb} ميغابايت",
  "img.failed": "تعذرت {n}",
  "err.Image can't be reduced to the size limit with acceptable quality": "ما قدرنا نصغّر الصورة للحد المسموح بجودة مقبولة",
  "err.Only JPG, PNG, WEBP or HEIC images are allowed": "الصيغ المسموحة: JPG أو PNG أو WEBP أو HEIC",
  "err.Image compression is already running": "ضغط الصور شغال حالياً",
  "nav.choose": "افتح الموقع بواسطة",
  "nav.otherApps": "تطبيقات أخرى على هاتفي",
  "nav.copy": "نسخ الإحداثيات",
  "nav.copied": "انتسخت الإحداثيات",
  "nav.hint": "إذا التطبيق مثبت على هاتفك راح ينفتح مباشرة، وإذا مو مثبت ينفتح بالمتصفح.",
  "nav.categories": "التصنيفات",
  "cat.title": "التصنيفات",
  "cat.sub": "كل تصنيفات المنصة بمكان واحد. التصنيف المستخدم ما ينحذف إلا بعد حذف الأماكن أو الفعاليات اللي عليه.",
  "cat.tab.venues": "تصنيفات الأماكن",
  "cat.tab.events": "تصنيفات الفعاليات",
  "cat.tab.spots": "تصنيفات الأماكن العامة",
  "sc.title": "تصنيفات الأماكن العامة",
  "sc.sub": "تظهر للزبائن في صفحة الأماكن العامة وعند اقتراح مكان",
  "sc.inUse": "ما ينحذف، عليه {n} مكان عام أو اقتراح",
  "sc.count": "{n} مكان عام",
  "err.This category is used by public spots": "هذا التصنيف مستخدم بأماكن عامة",
  "err.Image dimensions are too large": "أبعاد الصورة كبيرة جداً",
  "err.Cross-site request blocked": "تم رفض الطلب لأنه صادر من موقع آخر",
  "audit.reason": "السبب",
  "audit.today": "اليوم",
  "audit.yesterday": "أمس",
  "b7.filterAction": "ابحث باسم العملية أو الشخص",
  "la.confirmNotMeCust": "راح نسجّل خروج هذا الجهاز من حسابك، وننصحك تغيّر كلمة المرور. نكمل؟",
  "la.signedOutCust": "طلّعنا الجهاز الغريب من حسابك. غيّر كلمة المرور من ملفك الشخصي.",
  "cs.title": "شنو يشوف الزبائن",
  "cs.note": "اختار الأقسام اللي تظهر للزبائن بالتطبيق والصفحة الرئيسية. القسم المخفي يختفي بالكامل، وياه الحجوزات والمفضلة المرتبطة بيه.",
  "cs.both": "الكل",
  "cs.bothNote": "الفعاليات وأماكنها والأماكن العامة",
  "cs.events": "الفعاليات بس",
  "cs.eventsNote": "الفعاليات والأماكن اللي تنحجز، بدون الأماكن العامة",
  "cs.spots": "الأماكن العامة بس",
  "cs.spotsNote": "بدون فعاليات ولا حجوزات",
  "cs.saved": "انحفظت الأقسام الظاهرة للزبائن",
  "err.Bookings are currently unavailable": "الحجوزات مو متاحة حالياً",
  "la.title": "دخول جديد لحسابك",
  "la.body": "تم تسجيل الدخول من {device} بتاريخ {time}.",
  "la.me": "هذا أنا",
  "la.notMe": "مو أنا",
  "la.confirmNotMe": "راح نسجّل خروج كل الأجهزة الثانية من حسابك، وبعدها ننصحك تغيّر كلمة المرور. نكمل؟",
  "la.signedOut": "سجّلنا خروج كل الأجهزة الثانية. غيّر كلمة المرور هسه من الإعدادات.",
  "err.This alert is for the device you are using now": "هذا التنبيه يخص الجهاز اللي تستخدمه هسه",
  "err.Alert not found": "التنبيه غير موجود",
  "dev.title": "أجهزتي المسجلة",
  "dev.sub": "الأجهزة اللي دخلت لحسابك. إذا شفت جهاز ما تعرفه سجّل خروجه وغيّر كلمة المرور.",
  "dev.empty": "ما فيه أجهزة مسجلة بعد. تظهر هنا بعد تسجيل الدخول القادم.",
  "dev.current": "هذا الجهاز",
  "dev.last": "آخر استخدام {time}",
  "dev.signout": "تسجيل خروج",
  "dev.confirm": "تسجيل خروج {device} من حسابك؟",
  "dev.done": "تم تسجيل خروج الجهاز",
  "rp.from": "رد {name}",
  "rp.reply": "رد",
  "rp.edit": "تعديل الرد",
  "rp.delete": "حذف الرد",
  "rp.publish": "نشر الرد",
  "rp.placeholder": "اكتب ردك للزبون، يظهر للجميع تحت التقييم",
  "rp.saved": "انتشر الرد",
  "rp.confirmDelete": "حذف هذا الرد؟",
  "rp.adminDelete": "حذف رد الشريك",
  "rp.deleted": "انحذف الرد",
  "err.Only a device you used before this sign-in can answer this alert": "هذا التنبيه يُجاوَب من جهاز كنت تستخدمه قبل هذا الدخول",
  "err.Write a reply": "اكتب الرد",
  "err.Device not found": "الجهاز غير موجود",
  "err.Use sign out for the device you are using now": "لتسجيل خروج هذا الجهاز استخدم زر تسجيل الخروج",
  "err.Only the owner can do this": "هذا الإجراء للمالك فقط",
  "cx.headNoShow": "زبون ما حضر فعالية — الحجز موقوف عنده",
  "cx.headDispute": "اعتراض على سجل الحضور",
  "cx.state.waitingCustomer": "ننتظر الزبون يوضّح سبب غيابه. ما يقدر يحجز لحد ما تقرر، وتقدر تقرر هسه إذا تريد.",
  "cx.state.awaiting_admin": "الزبون أرسل توضيح وينتظر قرارك.",
  "cx.state.open": "مفتوحة وتنتظر قرارك.",
  "cx.state.approved": "انقبلت — الزبون يقدر يحجز من جديد.",
  "cx.state.rejected": "انرفضت — الإيقاف باقي.",
  "cx.customer": "الزبون",
  "cx.phone": "الهاتف",
  "cx.event": "الفعالية",
  "cx.venue": "المكان",
  "cx.date": "تاريخ الفعالية",
  "cx.guests": "عدد الأشخاص",
  "cx.explain": "توضيح الزبون",
  "cx.messages": "الرسائل",
  "cx.noExplain": "ما أرسل توضيح بعد.",
  "cx.lift": "رفع الإيقاف",
  "cx.liftHint": "يرجع الزبون يقدر يحجز",
  "cx.keep": "إبقاء الإيقاف",
  "cx.keepHint": "يبقى ممنوع من الحجز ويقدر يرسل توضيح جديد",
  "cx.acceptHint": "يتصحح سجل الحضور لصالح الزبون",
  "cx.rejectDispute": "رفض الاعتراض",
  "cx.rejectHint": "يبقى سجل الحضور مثل ما هو",
  "b6.casesSub": "هنا تراجع الزبائن اللي ما حضروا فعالياتهم (ويتوقف حجزهم تلقائياً) واعتراضاتهم، وتقرر ترفع الإيقاف أو تبقيه",
  "cx.short.waitingCustomer": "بانتظار توضيح",
  "cx.short.awaiting_admin": "وصل توضيح",
  "cx.short.open": "مفتوحة",
  "cx.short.approved": "رُفع الإيقاف",
  "cx.short.rejected": "باقي الإيقاف",
  "cx.missed": "غياب",
  "cx.wa": "واتساب",
  "cx.waMsg": "مرحباً {name}، معك إدارة منصة «وين نروح». لاحظنا عدم حضورك لفعالية «{event}» بتاريخ {date}، ولهذا توقف الحجز بحسابك مؤقتاً. ممكن توضح لنا السبب حتى نراجع الحالة؟",
  "apg.title": "تنزيل أو حذف سجلات فترة معينة",
  "apg.note": "اختار الفترة، نزّل نسخة (ملف يفتح بالإكسل) إذا تريد، وبعدها احذف. الحذف نهائي وما يترك أثر.",
  "apg.from": "من تاريخ",
  "apg.to": "إلى تاريخ",
  "apg.download": "تنزيل نسخة",
  "apg.delete": "حذف السجلات",
  "apg.confirm": "راح ينحذف {n} سجل من {from} إلى {to} نهائياً بدون رجعة. نزّلت نسخة؟ نكمل الحذف؟",
  "apg.done": "انحذف {n} سجل",
  "apg.none": "ما فيه سجلات بهذي الفترة",
  "apg.col.time": "الوقت",
  "apg.col.action": "العملية",
  "apg.col.actor": "الشخص",
  "apg.col.role": "الدور",
  "apg.col.target": "على",
  "apg.col.id": "المعرّف",
  "apg.col.details": "التفاصيل",
  "err.Choose valid dates": "اختار تواريخ صحيحة",
  "err.The start date must be before the end date": "تاريخ البداية لازم يكون قبل تاريخ النهاية",
  "pc.exempt": "معفى",
  "pc.wa": "واتساب",
  "pc.invite": "دعوة شريك جديد",
  "pc.search": "ابحث باسم الشريك أو الهاتف أو المنطقة",
  "pc.all": "الكل",
  "onb.skip": "تخطي",
  "onb.next": "التالي",
  "onb.prev": "السابق",
  "onb.register": "سجّل الآن",
  "onb.browse": "تصفح أولاً",
  "onb.title": "الشاشات التعريفية",
  "onb.note": "تظهر للزائر أول ما يفتح التطبيق وقبل التسجيل. أي تعديل تحفظه يخليها تظهر من جديد لكل الزوار.",
  "onb.slide": "الشاشة {n}",
  "onb.up": "تحريك للأعلى",
  "onb.down": "تحريك للأسفل",
  "onb.delete": "حذف الشاشة",
  "onb.titleAr": "العنوان",
  "onb.bodyAr": "النص",
  "onb.english": "النص بالإنكليزي (اختياري)",
  "onb.titleEn": "العنوان بالإنكليزي",
  "onb.bodyEn": "النص بالإنكليزي",
  "onb.add": "إضافة شاشة",
  "onb.preview": "معاينة",
  "onb.saved": "انحفظت الشاشات التعريفية",
  "err.Upload the slide image from the app": "ارفع صورة الشاشة من التطبيق",
  "err.Title is required": "العنوان مطلوب",
  "onb.needTitle": "اكتب عنوان الشاشة {n} قبل الحفظ",
  "err.Each screen must have a unique id": "في شاشات مكررة، احذف المكرر وحاول مرة ثانية",
  "hs.title": "واجهة الصفحة الرئيسية",
  "hs.note": "العنوان والوصف والصور اللي تتبدل أعلى الصفحة الرئيسية. اترك العنوان أو الوصف فارغ حتى يبقى النص الافتراضي.",
  "hs.titleAr": "العنوان",
  "hs.subAr": "الوصف",
  "hs.titleEn": "العنوان بالإنكليزي",
  "hs.subEn": "الوصف بالإنكليزي",
  "hs.images": "الصور المتبدلة (لحد 8)",
  "hs.labelAr": "كلمة على الصورة، مثل: أمسيات",
  "hs.labelEn": "English label",
  "hs.delete": "حذف الصورة",
  "hs.add": "إضافة صورة",
  "hs.interval": "تتبدل كل",
  "hs.seconds": "{n} ثواني",
  "hs.saved": "انحفظت واجهة الصفحة الرئيسية",
  "hs.needImage": "ارفع صورة رقم {n} أو احذفها قبل الحفظ",
  "err.Upload the image from the app": "ارفع الصورة من التطبيق",
  "err.Each image must have a unique id": "في صور مكررة، احذف المكرر وحاول مرة ثانية",
  "reg.more": "خيارات أكثر",
  "ap.search": "ابحث باسم المكان أو الشريك أو المدينة",
  "bm.title": "نوع الحجز",
  "bm.open": "مفتوح",
  "bm.openHint": "يستقبل حجوزات بدون حد، وما ينغلق إلا إذا أغلقته أنت أو بالوقت اللي تحدده",
  "bm.single": "لمرة واحدة",
  "bm.singleHint": "ينغلق تلقائياً أول ما تقبل حجز واحد (مثل حجز المكان كامل لشخص واحد)",
  "bm.singleBadge": "لمرة واحدة",
  "bm.repeat": "تكرار لأيام متتالية",
  "bm.repeatHint": "عدد الأيام (1 – 30). تنشأ فعالية لكل يوم يلي الآخر بنفس الوقت والبيانات.",
  "bm.days": "يوم",
  "bm.until": "آخر يوم: {d}",
  "ve.seriesSaved": "انحفظت {n} فعاليات لأيام متتالية",
  "err.This one-time event is already booked": "هذي الفعالية لمرة واحدة ومحجوزة مسبقاً",
  "bm.skip": "تخطي أيام معينة (اضغط على اليوم حتى ما تنشأ فيه فعالية)",
  "bm.count": "راح تنشأ {n} فعالية",
  "notif.extend": "تمديد",
  "ve.extendFrom": "تمديد سلسلة «{title}»",
  "ve.extendHint": "البداية من اليوم اللي بعد آخر فعالية وبنفس الوقت والبيانات. غيّر عدد الأيام أو تخطي الأيام إذا تحتاج، واحفظ.",
  "ml.label": "الصق رابط Google Maps",
  "ml.placeholder": "https://maps.app.goo.gl/…",
  "ml.paste": "لصق",
  "ml.go": "تحديد",
  "ml.hint": "من Google Maps: اضغط «مشاركة» ← «نسخ الرابط»، والصقه هنا. يقبل الإحداثيات أيضاً مثل 33.31, 44.36",
  "ml.done": "انحط الموقع على الخريطة",
  "ml.noClip": "ما قدرنا نقرأ الحافظة، الصق الرابط يدوياً",
  "err.Couldn't read a location from this link": "ما قدرنا نقرأ الموقع من هذا الرابط. تأكد إنه رابط Google Maps لمكان محدد",
  "lm.button": "استخدم موقعي الحالي",
  "lm.locating": "جاري تحديد موقعك…",
  "lm.done": "انحط موقعك الحالي على الخريطة، تأكد منه واحفظ",
  "dp.title": "المنصة بالأرقام",
  "dp.customers": "الزبائن",
  "dp.partners": "الشركاء",
  "dp.places": "الأماكن العامة المنشورة",
  "dp.events": "فعاليات قادمة",
  "dp.spots": "الأماكن العامة",
  "dp.week": "+{n} هذا الأسبوع",
  "dp.active": "{n} نشط",
  "dp.suggest": "{n} اقتراح بانتظارك",
  "dp.hidden": "{n} مخفي",
  "cl.tab.login": "تسجيل الدخول",
  "cl.tab.register": "حساب جديد",
  "cl.registerTitle": "أنشئ حسابك",
  "cl.registerSub": "كل الحقول مطلوبة. بعد التسجيل توصلك إدارة المنصة رمز تفعيل من 6 أرقام.",
  "cl.name": "الاسم الكامل",
  "cl.phone": "رقم الهاتف",
  "cl.create": "إنشاء الحساب",
  "cl.registered": "انسجل طلبك، انتظر رمز التفعيل",
  "cl.otpTitle": "تفعيل الحساب",
  "cl.otpSub": "أدخل رمز التفعيل اللي توصلك من إدارة المنصة",
  "cl.otpNote": "إدارة «وين نروح» راح ترسل لك رمز من 6 أرقام على واتساب للرقم",
  "cl.activate": "تفعيل الحساب",
  "cl.activated": "تفعّل حسابك، أهلاً بيك!",
  "cl.resend": "اطلب رمز جديد",
  "cl.resent": "انطلب رمز جديد، راح يوصلك قريباً",
  "cl.back": "رجوع",
  "cl.haveCode": "عندي رمز تفعيل",
  "cl.needPhone": "اكتب رقم هاتفك أولاً",
  "cl.forceTitle": "غيّر كلمة المرور",
  "cl.forceSub": "دخلت بكلمة مرور مؤقتة. اختار كلمة مرور جديدة خاصة بيك حتى تكمل.",
  "nav.activations": "التفعيل",
  "rs.link": "نسيت كلمة المرور؟",
  "rs.title": "إعادة تعيين كلمة المرور",
  "rs.sub": "اطلب رمز، وإدارة المنصة ترسله لك على واتساب",
  "rs.request": "اطلب رمز إعادة التعيين",
  "rs.requested": "انطلب الرمز، راح يوصلك على واتساب قريباً",
  "rs.haveCode": "عندي رمز إعادة تعيين",
  "rs.note": "إدارة «وين نروح» راح ترسل لك رمز من 6 أرقام على واتساب للرقم",
  "rs.code": "رمز إعادة التعيين",
  "rs.save": "حفظ كلمة المرور الجديدة",
  "rs.done": "تغيّرت كلمة المرور وطلعت من كل أجهزتك الثانية",
  "act.resets": "طلبات نسيت كلمة المرور",
  "act.resetsNone": "ما فيه طلبات إعادة تعيين",
  "act.locked": "انقفل الرمز",
  "act.resetMsg": "هلا {name}، رمز إعادة تعيين كلمة المرور في «وين نروح» هو: {code}\nإذا ما طلبته تجاهل الرسالة.\n{site}/login",
  "dev.all": "تسجيل خروج من كل الأجهزة الثانية",
  "dev.allConfirm": "تسجيل خروج كل الأجهزة غير هذا الجهاز؟",
  "dev.allDone": "طلعت من {n} جهاز",
  "act.title": "تفعيل حسابات الزبائن",
  "act.sub": "أرسل رمز التفعيل لكل زبون جديد على واتساب. الرمز يبقى صالح لحين استخدامه، ولمرة وحدة بس.",
  "act.pending": "بانتظار التفعيل",
  "act.none": "ما فيه زبائن بانتظار التفعيل",
  "act.expired": "انتهى الرمز",
  "act.until": "صالح لحد {d}",
  "act.needNew": "اطلب رمز جديد",
  "act.attempts": "محاولات خاطئة: {n}",
  "act.send": "أرسل بواتساب",
  "act.renew": "رمز جديد",
  "act.renewed": "انعمل رمز جديد",
  "act.msg": "هلا {name}، رمز تفعيل حسابك في «وين نروح» هو: {code}\n{site}/login",
  "act.temps": "كلمات مرور مؤقتة للزبائن السابقين",
  "act.tempsNote": "زبائن سجلوا قبل بـGoogle. أرسل لكل واحد كلمة مروره المؤقتة، وراح يغيّرها أول ما يدخل.",
  "act.tempMsg": "هلا {name}، صار الدخول إلى «وين نروح» برقم الهاتف وكلمة المرور.\nرقمك: {phone}\nكلمة المرور المؤقتة: {pw}\nغيّرها أول ما تدخل.\n{site}/login",
  "reg.resetPwMsgCustomer": "هلا، كلمة المرور المؤقتة لحسابك في «وين نروح» هي: {p}\nادخل برقم هاتفك وغيّرها أول ما تدخل.\n{site}/login",
  "err.Invalid phone number or password": "رقم الهاتف أو كلمة المرور غلط",
  "err.Account not activated": "الحساب بعده ما تفعّل",
  "err.This phone number is already registered": "هذا الرقم مسجل من قبل، سجّل دخولك",
  "err.Invalid or expired code": "الرمز غلط أو منتهي",
  "err.Too many wrong codes. Request a new code": "محاولات خاطئة كثيرة، اطلب رمز جديد",
  "err.Wait a minute before requesting a new code": "انتظر دقيقة قبل ما تطلب رمز جديد",
  "err.Enter your full name": "اكتب اسمك الكامل",
  "err.Google sign-in is no longer available. Sign in with your phone number": "الدخول بـGoogle توقف، ادخل برقم هاتفك",
  "reg.resetPwDoneCustomer": "تغيّرت كلمة المرور. أرسلها للزبون على واتساب:",
  "err.This phone number is awaiting activation. Enter your activation code": "هذا الرقم بانتظار التفعيل، أدخل رمز التفعيل",
  "err.Change your temporary password first": "غيّر كلمة المرور المؤقتة أولاً",
};

const en: Dict = {
  appName: "Wayn Nrouh",
  tagline: "Your next outing starts here",
  "hero.eyebrow": "Evenings · Horse riding · Motorcycling · Arts",
  "hero.title": "Where to today?",
  "pp.partners": "Partner places",
  "pp.platform": "Platform places",
  "err.The location must be inside Iraq": "The location must be inside Iraq",
  "err.Pick the place location on the map": "Pick the place location on the map",
  "err.This place has upcoming events": "Can't turn off: this place has upcoming events.",
  "err.This place does not offer events": "This place does not host events. The admin decides this.",
  "pp.f.image": "Main photo",
  "pp.f.gallery": "Photos",
  "pp.f.lng": "Longitude",
  "pp.f.lat": "Latitude",
  "pp.f.description_en": "English description",
  "pp.f.description_ar": "Description",
  "pp.f.hours_ar": "Opening hours",
  "pp.f.address": "Address",
  "pp.f.area_en": "Area (English)",
  "pp.f.area": "Area",
  "pp.f.city": "City",
  "pp.f.governorate": "Governorate",
  "pp.f.type": "Category",
  "pp.f.name_en": "English name",
  "pp.f.name_ar": "Name",
  "pp.gpsPicked": "Location picked. Press save to send it.",
  "pp.photosN": "{n} photos",
  "pp.changes": "Requested changes",
  "pp.editBadge": "Edit",
  "pp.editSent": "Edit sent for admin approval",
  "pp.editHint": "Any change you save goes to the admin for approval before customers see it.",
  "pp.editRejected": "Your last edit was not approved: {r}. The previous details stay live.",
  "pp.editPending": "Your changes are waiting for admin approval. The previous details stay live until then.",
  "pp.eventsOffToast": "Events turned off for this place",
  "pp.eventsOnToast": "This place can now add events",
  "pp.eventsQuestion": "Does this place host events?",
  "pp.eventsShort": "Events",
  "pp.eventsOff": "No events",
  "pp.eventsOn": "Hosts events",
  "pp.suggestSent": "Place suggestion sent to the admin",
  "pp.suggestHint": "Same details as a public place. After admin approval it shows to customers in public places, and the admin decides whether it hosts events.",
  "pp.suggestTitle": "Suggest a public place",
  "pp.noLocationPartner": "Set the place location on the map from Edit so customers can see it in public places.",
  "pp.noLocationAdmin": "No location: hidden from public places",
  "hero.subtitle": "Discover the best events and places in Iraq, from evenings and sports to family outings and arts, and book in a tap.",
  "hero.cta": "Explore events",
  "hero.ctaSpots": "Explore public places",
  "hero.partner": "Own a venue? Join us",
  "explore.title": "Places worth visiting",
  "explore.empty": "No places in this category yet — try another one",
  "type.all": "All",
  "type.restaurant": "Restaurants",
  "type.event": "Events",
  "type.cinema": "Cinema",
  "type.sports": "Sports",
  "type.trips": "Trips",
  "type.other": "Other",
  "nav.home": "Explore",
  "nav.bookings": "My Bookings",
  "nav.profile": "Profile",
  "nav.myVenues": "My public places",
  "nav.venueBookings": "Bookings",
  "nav.team": "Team",
  "nav.settings": "Settings",
  "nav.adminVenues": "Venues",
  "nav.adminPartners": "Partners",
  "nav.partnersShort": "Partners",
  "nav.adminPlaces": "Public places",
  "ap.title": "Public places",
  "ap.sub": "All partner places, plus new places waiting for your approval.",
  "ap.all": "All places",
  "ap.empty": "No places yet",
  "ap.view": "View page",
  "ap.partnerDisabled": "Partner disabled",
  "bookings.location": "Location",
  "nav.adminBookings": "Bookings",
  "nav.adminCases": "Cases",
  "nav.checkinShort": "Check-in",
  "nav.bookingsShort": "Bookings",
  "nav.auditShort": "Audit",
  "nav.financeShort": "Finance",
  "nav.venuesShort": "Places",
  "b6.approveDispute": "Accept dispute",
  "b6.rejectedNote": "Your previous request was declined. You can send a new explanation to the admin",
  "role.customer": "Customer",
  "role.venue": "Venue",
  "role.admin": "Admin",
  "role.owner": "Owner",
  "role.staff": "Reception",
  "auth.login": "Sign in",
  "auth.logout": "Sign out",
  "auth.google": "Continue with Google",
  "auth.customerTitle": "Hey there! Sign in",
  "auth.customerSub": "Sign in with your phone number and password to send and track bookings.",
  "auth.googleOnly": "No new email or password needed — your Google account is enough.",
  "err.This phone number is used by another account": "This phone number is used by another account",
  "auth.partnerLink": "Venue & admin sign-in",
  "auth.partnerTitle": "Venue & admin sign-in",
  "auth.partnerSub": "Sign in with your username and password.",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.submit": "Sign in",
  "auth.noAccount": "No venue account?",
  "auth.registerLink": "Register your venue",
  "auth.customerLink": "Customer? Sign in here",
  "auth.registerTitle": "Register your venue",
  "auth.registerSub": "Our team will review your request and activate your account.",
  "auth.businessName": "Business name",
  "auth.fullName": "Your name",
  "auth.phone": "Phone",
  "auth.city": "Governorate",
  "auth.registerSubmit": "Submit request",
  "auth.haveAccount": "Have an account?",
  "auth.signingIn": "Hang tight, getting things ready...",
  "pending.title": "Your request is under review",
  "pending.body": "We received your venue registration. Our team will review it soon and notify you once it's active.",
  "rejected.title": "Request not approved",
  "rejected.body": "Unfortunately your venue account wasn't approved. Contact support for details.",
  "status.pending": "Pending",
  "status.approved": "Active",
  "status.rejected": "Rejected",
  "status.confirmed": "Confirmed",
  "status.cancelled": "Cancelled",
  "venue.spots": "spots",
  "venue.book": "Book now",
  "booking.title": "Book your spot",
  "booking.date": "Date",
  "booking.guests": "Guests",
  "booking.confirm": "Confirm booking",
  "booking.success": "Booked! Your ticket is in My Bookings",
  "booking.loginNeeded": "Sign in as a customer to book",
  "booking.noPayment": "Pay at the venue — no online payments yet",
  "bookings.title": "My Bookings",
  "bookings.empty": "No bookings yet. Let's find you a great outing!",
  "bookings.showQr": "Show ticket",
  "bookings.code": "Booking code",
  "bookings.offline": "You're offline — showing tickets saved on your device",
  "bookings.savedOffline": "Saved on your device, works offline",
  "bookings.copy": "Copy code",
  "bookings.copied": "Code copied",
  "bookings.saveImage": "Save image",
  "bookings.cancel": "Cancel booking",
  "bookings.cancelled": "Booking cancelled",
  "bookings.guests": "guests",
  "bookings.customer": "Customer",
  "bookings.venue": "Venue",
  "bookings.emptyVenue": "No bookings yet",
  "notif.title": "Notifications",
  "notif.empty": "No new notifications",
  "notif.markRead": "Mark all as read",
  "profile.title": "Profile",
  "settings.title": "Settings",
  "settings.language": "Language",
  "settings.theme": "Dark mode",
  "settings.account": "Account info",
  "settings.platform": "Platform settings",
  "settings.platformSoon": "Advanced platform settings are coming in the next phase.",
  "myVenues.title": "My public places",
  "myVenues.sub": "Update your venues' details, photos and location at any time.",
  "myVenues.add": "Suggest a public place",
  "myVenues.empty": "No venues added yet",
  "myVenues.nameAr": "Arabic name",
  "myVenues.nameEn": "English name",
  "myVenues.type": "Category",
  "vc.title": "Venue categories",
  "vc.sub": "Partners pick their venue's category from this list only.",
  "vc.readOnly": "Only the general manager can manage categories.",
  "vc.new": "New category",
  "vc.edit": "Edit category",
  "vc.delete": "Delete category",
  "vc.saved": "Category saved",
  "vc.deleted": "Category deleted",
  "vc.count": "{n} venues",
  "vc.inUse": "Can't delete: {n} venues use it. Change their category first.",
  "vc.confirmDelete": "Delete the “{name}” category permanently?",
  "myVenues.image": "Image URL",
  "myVenues.description": "Description",
  "myVenues.created": "Place added and sent to the platform team for approval",
  "myVenues.booked": "booked",
  "team.title": "Team Members",
  "team.sub": "Add your staff under the same venue account.",
  "team.add": "Add member",
  "team.added": "Member added",
  "team.removed": "Member removed",
  "team.remove": "Remove",
  "team.role": "Role",
  "team.you": "You",
  "team.ownerOnly": "Only the owner can manage the team",
  "admin.whatsapp": "WhatsApp",
  "admin.waMsg": "Hello, this is the Wayn Nrouh team about the partner registration for “{name}”.",
  "admin.venuesTitle": "Venue Management",
  "admin.venuesSub": "Review and approve new venue requests.",
  "admin.approve": "Approve & activate",
  "admin.reject": "Reject",
  "admin.venuesCount": "venues",
  "admin.empty": "No venue accounts yet",
  "admin.bookingsTitle": "All Bookings",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.loading": "Loading...",
  "common.error": "Something went wrong, please try again",
  "common.dashboard": "Dashboard",
  "common.back": "Back",
  "np.title": "Notifications",
  "np.reminders.title": "Event reminders",
  "np.reminders.sub": "Remind me about confirmed bookings a day and two hours before.",
  "np.fav_events.title": "Events at my favourite places",
  "np.fav_events.sub": "Notify me when a new event is added at a place in my favourites.",
  "np.on": "Saved: alerts on",
  "np.off": "Saved: alerts off",
  "pe.share": "Share event on WhatsApp",
  "fe.title": "Events at my favourite places",
  "fe.sub": "Notify me when a new event is added at a place in my favourites.",
  "fe.on": "You will be notified about new events",
  "fe.off": "New event alerts turned off",
  "about.share": "Share the app with friends",
  "about.shareMsg": "Try Wayn Nrouh — find public places and events and book easily:",
  "legal.privacy": "Privacy policy",
  "legal.terms": "Terms of use",
  "legal.updated": "Last updated:",
  "legal.empty": "Coming soon.",
  "legal.agree1": "I agree to the",
  "legal.and": "and",
  "legal.adminTitle": "Terms of use & privacy policy",
  "legal.saved": "Text saved",
  "pe.title": "Upcoming events here",
  "pe.all": "Show all ({n})",
  "pe.less": "Show less",
  "err.You must accept the terms and privacy policy": "You must accept the terms of use and privacy policy",
  "about.title": "About Wayn Nrouh",
  "about.version": "Version",
  "about.contact": "Contact us",
  "about.whatsapp": "Admin WhatsApp",
  "about.facebook": "Our Facebook page",
  "about.default": "Wayn Nrouh helps you find public places and events near you and book them easily.",
  "about.adminTitle": "About page",
  "about.adminNote": "The text shown on the page and the Facebook link. WhatsApp uses the admin contact number.",
  "about.textAr": "About text (Arabic)",
  "about.textEn": "About text (English, optional)",
  "about.saved": "About page saved",
  "err.Enter a valid Facebook link": "Enter a valid Facebook link",
  "nav.checkin": "Check-in",
  "details.back": "Back",
  "details.about": "About",
  "details.location": "Location",
  "details.openMap": "Open in maps",
  "details.noLocation": "Location not set yet",
  "details.notFound": "We couldn't find this place",
  "details.photos": "photos",
  "myVenues.edit": "Edit",
  "edit.title": "Edit venue",
  "edit.photos": "Venue photos",
  "edit.photosHint": "The first photo is the cover. JPG, PNG or WEBP up to 8MB",
  "edit.upload": "Upload photos",
  "edit.uploading": "Uploading...",
  "edit.cover": "Cover",
  "edit.makeCover": "Make cover",
  "edit.remove": "Remove",
  "edit.location": "Venue location",
  "edit.locationHint": "Tap the map to set the venue location",
  "edit.gpsButton": "Use my current location",
  "edit.gpsLocating": "Finding your location…",
  "edit.gpsSaved": "Place location pinned and saved",
  "edit.gpsDenied": "Allow location access in your browser settings and try again",
  "edit.gpsFailed": "Couldn't get your location. Turn on GPS and try again",
  "edit.gpsUnsupported": "Your device doesn't support location",
  "edit.address": "Address",
  "edit.descEn": "English description",
  "edit.saved": "Changes saved",
  "edit.viewPublic": "View venue page",
  "edit.details": "Details",
  "checkin.title": "Check-in",
  "checkin.sub": "Scan the QR on the customer's ticket or enter the booking code",
  "checkin.startCam": "Start camera",
  "checkin.stopCam": "Stop camera",
  "checkin.manual": "Or enter booking code",
  "checkin.find": "Find",
  "checkin.confirm": "Confirm arrival",
  "checkin.done": "Checked in successfully",
  "checkin.already": "This booking was already checked in",
  "checkin.cancelledNote": "This booking is cancelled and can't be checked in",
  "checkin.camError": "Couldn't start the camera, use manual entry",
  "checkin.at": "Arrived at",
  "checkin.by": "by",
  "checkin.scanAgain": "Scan another ticket",
  "status.checked_in": "Arrived",
  "reminder.button": "Remind",
  "reminder.title": "Remind me",
  "reminder.sub": "Pick a time that suits you and we'll send an in-app alert with your ticket",
  "reminder.at": "Reminder time",
  "reminder.repeat": "Repeat",
  "reminder.repeat.none": "Once",
  "reminder.repeat.1h": "Every hour",
  "reminder.repeat.3h": "Every 3 hours",
  "reminder.repeat.daily": "Every day",
  "reminder.repeatHint": "Repeats stop automatically after you check in, the booking ends or is cancelled",
  "reminder.save": "Save reminder",
  "reminder.remove": "Remove reminder",
  "reminder.saved": "Reminder set",
  "reminder.removed": "Reminder removed",
  "reminder.chip": "Reminder",
  "reminder.ended": "Reminder finished",
  "explore.list": "List",
  "explore.map": "Map",
  "explore.nearMe": "Near me",
  "explore.locating": "Finding you...",
  "explore.locError": "Couldn't get your location, please allow location access",
  "explore.youAreHere": "You are here",
  "explore.km": "km",
  "explore.details": "Details",
  "search.placeholder": "Search events, venues, areas, artists or programs...",
  "search.clear": "Clear search",
  "search.empty": "No results for",
  "share.whatsapp": "Share on WhatsApp",
  "share.more": "Share",
  "share.text": "Let's go out together! 🎉 I booked {venue} on {date} for {guests} people. Venue details:",
  "nav.favorites": "Favourites",
  "fav.add": "Add to favourites",
  "fav.remove": "Remove from favourites",
  "fav.added": "Added to favourites",
  "fav.removed": "Removed from favourites",
  "fav.title": "Your favourites",
  "fav.sub": "Events and places you saved to come back to quickly",
  "fav.empty": "No saved places yet. Tap the heart on any place you like",
  "b4.filters": "Filters",
  "b4.allAreas": "All areas",
  "b4.anyPrice": "Any price",
  "b4.free": "Free only",
  "b4.iqd": "In dinars (IQD)",
  "b4.usd": "In dollars (USD)",
  "b4.min": "Min",
  "b4.max": "Max",
  "b4.sortDate": "Soonest",
  "b4.sortPrice": "Lowest price",
  "b4.currencyNote": "Prices are compared within one currency only — dinars and dollars are never converted",
  "b4.anyAudience": "All audiences",
  "b4.anyCategory": "All categories",
  "b4.anyProgram": "All programs",
  "b4.clear": "Clear filters",
  "b4.count": "{n} events",
  "b4.countOne": "1 event",
  "b4.minMax": "Minimum must be lower than maximum",
  "fav.loginNeededEvent": "Sign in as a customer to save your favourite events",
  "b4.matched": "From",
  "cal.add": "Add to calendar",
  "cal.google": "Google Calendar",
  "cal.ics": "Calendar file (Apple / Outlook)",
  "share.event": "Check out this event on Wayn Nrouh 🎉 {title} — {date}",
  "share.copyLink": "Copy link",
  "share.venue": "Check out this place on Wayn Nrouh 🎉 {name}",
  "share.copied": "Link copied",
  "fav.tabEvents": "Events",
  "fav.tabVenues": "Places",
  "fav.emptyEvents": "No saved events yet. Tap the heart on any event you like",
  "edit.area": "Area",
  "bst.pending": "Awaiting confirmation",
  "bst.confirmed": "Confirmed",
  "bst.rejected": "Declined",
  "bst.unable_to_contact": "Unable to contact",
  "bst.expired": "Confirmation expired",
  "bst.cancelled": "Cancelled",
  "bst.attended": "Attended",
  "bst.completed": "Completed",
  "bst.no_show": "No show",
  "bst.checked_in": "Arrived",
  "b5.deadline": "The venue will confirm by {time}",
  "b5.noQrYet": "Your QR ticket appears once the venue confirms",
  "b5.reason": "Reason",
  "b5.reasonPh": "Write a clear reason",
  "b5.optional": "(optional)",
  "b5.confirm": "Confirm",
  "b5.reject": "Decline",
  "b5.unable": "Couldn't reach",
  "b5.whatsapp": "WhatsApp customer",
  "ve.f.autoClose": "Close requests automatically at (optional)",
  "ve.f.autoCloseHint": "Leave empty to keep requests open until you close them or the event ends.",
  "ve.f.autoCloseClear": "Clear",
  "ve.autoCloseAt": "Requests close automatically {when}",
  "pc.floating": "Ask on WhatsApp",
  "pc.msgUser": "Hello, I'm reaching out from the Wayn Nrouh app.\nName: {name}\nAccount: {email}\nType: {role}",
  "pc.msgPartner": "\nPartner: {business}",
  "vr.title": "Places awaiting approval",
  "vr.whatsapp": "WhatsApp partner",
  "vr.waMsg": "Hello {business}, this is the Wayn Nrouh team about the place “{place}” you added. We'd like to confirm a few details before approving.",
  "vr.approve": "Approve",
  "vr.reject": "Reject",
  "vr.approved": "Place approved",
  "vr.rejected": "Place rejected",
  "vr.resubmitted": "Resubmitted",
  "vr.hidden": "Hidden · Inactive",
  "vr.noApproved": "No active place yet. Places appear here after platform approval.",
  "vr.resubmittedToast": "Saved and resubmitted for review",
  "vr.pendingNote": "Waiting for platform approval. The place is hidden from customers and can't have events until approved.",
  "vr.rejectedNote": "Not approved — Reason: {r}. Edit and save the place to resubmit it.",
  "rr.title": "Ready place rejection reasons",
  "rr.note": "Shown as quick buttons when rejecting a place. Tapping one fills the reason, which you can still edit.",
  "rr.add": "New reason",
  "rr.saved": "Reasons saved",
  "rr.ph": "Write the reason",
  "nav.accounts": "Accounts registry",
  "nav.accountsShort": "Accounts",
  "reg.title": "Accounts registry",
  "reg.sub": "All partners and customers with contact details and account controls.",
  "reg.partners": "Partners",
  "reg.customers": "Customers",
  "reg.search": "Search by name, email or phone",
  "reg.empty": "No accounts",
  "reg.joined": "Joined {d}",
  "reg.noPhone": "No phone number",
  "reg.wa": "WhatsApp",
  "common.close": "Close",
  "reg.waMsg": "Hello {name}, this is the Wayn Nrouh platform team.",
  "reg.disable": "Disable account",
  "reg.enable": "Enable account",
  "reg.disabled": "Account disabled",
  "reg.enabled": "Account enabled",
  "reg.disabledBadge": "Disabled",
  "reg.disableNotePartner": "The whole partner team is blocked from signing in and their places and events are hidden. Existing bookings are kept.",
  "reg.disableNoteCustomer": "The customer is blocked from signing in. Existing bookings are kept.",
  "reg.delete": "Delete",
  "reg.deleteTitle": "Delete “{name}”",
  "reg.blockedPartner": "A partner with places, upcoming events or active bookings can't be deleted. Cancel the events, then delete the places one by one here.",
  "reg.blockedCustomer": "A customer with active bookings can't be deleted. Cancel the bookings here first.",
  "reg.upcomingEvents": "Upcoming events",
  "reg.activeBookings": "{n} active bookings",
  "reg.cancelEvent": "Cancel event",
  "reg.places": "Places",
  "reg.placeHasEvents": "{n} upcoming events — cancel them first",
  "reg.placeFree": "Ready to delete",
  "reg.deletePlace": "Delete place",
  "reg.placeDeleted": "Place deleted",
  "reg.activeBookingsTitle": "Active bookings",
  "reg.cancelBooking": "Cancel booking",
  "reg.cancelled": "Cancelled",
  "reg.deleteWarn": "The account and all its data (past bookings, financial records, notifications) will be permanently deleted. This can't be undone.",
  "reg.deleteForever": "Delete permanently",
  "reg.deleted": "Account permanently deleted",
  "fm.per_booking": "Per booking",
  "fm.per_booking.hint": "Fixed amount for each booking whose guests actually attended",
  "fm.per_event": "Per event",
  "fm.per_event.hint": "Fixed amount for each event that ends without being cancelled, at any of the partner's places",
  "fm.monthly": "Monthly subscription",
  "fm.monthly.hint": "Fixed amount every month from the subscription start date",
  "fm.none": "No model",
  "b7.note.per_booking": "Attended booking fee",
  "b7.note.per_event": "Finished event fee",
  "b7.note.monthly": "Monthly subscription",
  "ms.title": "Monthly WhatsApp summaries",
  "ms.sub": "A ready message for each partner with the month's fees, payments and balance due. Tap to send.",
  "ms.empty": "No approved partners yet",
  "ms.due": "Due",
  "ms.send": "Send summary",
  "ms.resend": "Send again",
  "ms.sent": "Sent by {by} · {at}",
  "ms.msgHead": "Hello {name}, your Wayn Nrouh account summary for {month}:",
  "ms.msgLine": "• Net fees: {fees}\n• Paid: {paid}\n• Balance due at month end: {due}",
  "ms.msgNone": "No financial activity",
  "ms.msgFoot": "Thank you for partnering with us.",
  "fc.title": "Fee model comparison",
  "fc.sub": "Enter a price for each model to see what each partner would have paid based on the last 30 days. Green is the highest revenue for the platform.",
  "fc.currency": "Currency",
  "fc.activity": "{b} attended bookings · {e} finished events",
  "fc.current": "Current",
  "notif.new": "New",
  "notif.open": "Open",
  "notif.more": "and {n} more",
  "notif.f.all": "All",
  "notif.f.unread": "Unread",
  "notif.noUnread": "No unread notifications",
  "live.on": "Live",
  "live.updated": "Updated",
  "live.hint": "Data refreshes automatically every 30 seconds",
  "push.title": "Phone notifications",
  "push.enable": "Enable phone notifications",
  "push.disable": "Turn off on this device",
  "push.test": "Send a test notification",
  "push.testSent": "Test notification sent",
  "push.enabled": "Phone notifications enabled on this device",
  "push.denied": "Notifications are blocked — allow them in browser settings",
  "push.compact": "Enable phone notifications to get them even when the app is closed",
  "push.st.on": "On for this device — you'll get notifications even when the app is closed.",
  "push.st.off": "Off on this device.",
  "push.st.denied": "Blocked by the browser. Open site settings and allow notifications.",
  "push.st.unsupported": "This browser doesn't support phone notifications.",
  "push.st.ios-install": "On iPhone: tap Share → “Add to Home Screen”, open the app from the icon, then enable notifications.",
  "welcome.title": "Welcome {name}!",
  "welcome.sub": "One step before you start: enter your official name and phone so partners recognise you when you book.",
  "welcome.step": "Complete your account",
  "inst.title": "Add Wayn Nrouh to your Home Screen",
  "inst.sub": "Open it in one tap like any app, and get booking notifications even when it's closed.",
  "inst.install": "Install app",
  "inst.ios1": "Tap the Share button in Safari",
  "inst.ios2": "Choose “Add to Home Screen”",
  "auth.username": "Username",
  "auth.usernameHint": "English, no spaces, with at least one letter, one number and one symbol (like _ @ .). You'll sign in with it.",
  "auth.forgotWa": "Forgot password? Message the platform team",
  "auth.forgotAdmin": "Forgot password? Contact the platform team to set a new one.",
  "auth.forgotMsg": "Hi, I forgot my Wayn Nrouh partner password. Username: ",
  "reg.resetPw": "Set password",
  "reg.resetPwTitle": "Set a new password",
  "reg.resetPwUser": "Account",
  "reg.resetPwNew": "New password (at least 8 characters)",
  "reg.resetPwDone": "Password set. Send it to the partner on WhatsApp.",
  "reg.resetPwSend": "Send on WhatsApp",
  "reg.resetPwMsg": "Hi, a new password was set for your Wayn Nrouh account.\nUsername: {u}\nPassword: {p}\nPlease change it after signing in.",
  "sec.username": "Your sign-in username",
  "sec.copy": "Copy",
  "sec.copied": "Username copied",
  "sec.title": "Change password",
  "sec.current": "Current password",
  "sec.new": "New password (at least 8 characters)",
  "sec.confirm": "Confirm new password",
  "sec.save": "Save password",
  "sec.changed": "Password changed",
  "sec.mismatch": "Passwords don't match",
  "sec.tempNote": "Your current password is temporary from the platform team. We recommend changing it now.",
  "sec.tempBanner": "Your password is temporary from the platform team — please change it.",
  "sec.changeNow": "Change now",
  "bd.locked": "Booking details can't be edited after saving. Only the platform team can change them.",
  "bd.askChange": "Request a change on WhatsApp",
  "bd.changeMsg": "Hi, I'd like to change my Wayn Nrouh booking details.\nEmail: {email}\nCurrent name: {name}\nCurrent phone: {phone}\nNew details: ",
  "reg.editDetails": "Edit booking details",
  "fm.free_trial": "Free trial",
  "fm.free_trial.hint": "No fees for a set number of days; then the account is restricted until you pick a payment plan",
  "admin.trialDays": "Free trial length (days)",
  "admin.trialUntil": "Ends on {date}; you'll get a reminder 3 days before",
  "admin.trialEnds": "ends {date}",
  "share.waShort": "WhatsApp",
  "bookings.copyShort": "Copy code",
  "bookings.saveShort": "Save image",
  "cal.short": "Calendar",
  "pc.title": "Contact the platform team",
  "pc.sub": "Have a question or an issue? Message the platform manager directly on WhatsApp.",
  "pc.button": "WhatsApp platform manager",
  "pc.msg": "Hello, I'm reaching out from the Wayn Nrouh app.",
  "pc.adminTitle": "Platform manager WhatsApp",
  "pc.adminNote": "A contact button appears in customer and partner settings, plus a floating button on the home page. Leave empty to hide them.",
  "pc.saved": "Number saved",
  "b5.lastContact": "Last contact: {by} · {when}",
  "b5.contactTimes": "{n} times",
  "wat.title": "Ready WhatsApp messages",
  "wat.hint": "Shown when tapping “WhatsApp customer” on a booking card. Use {name}, {event}, {date} and {guests} as placeholders.",
  "wat.name": "Message name",
  "wat.add": "New message",
  "wat.delete": "Delete",
  "wat.save": "Save messages",
  "wat.saved": "Messages saved",
  "b5.cancelTitle": "Cancel booking",
  "b5.lateWarn": "The free-cancellation window ended ({time}). Cancelling now is referred for review",
  "b5.cancelUntil": "You can cancel until {time}",
  "b5.keep": "Back",
  "b5.send": "Submit",
  "b5.change": "Change people",
  "b5.changeTitle": "Change number of people",
  "b5.changeNote": "Changes to a confirmed booking need the venue's approval. The per-person price stays as when you booked",
  "b5.newTotal": "New total",
  "b5.changePending": "Change to {n} people awaiting the venue",
  "b5.changeRejected": "Change declined: {r}",
  "b5.changeSent": "Change request sent",
  "b5.changed": "Headcount updated",
  "b5.material": "Important event details changed ({f}). Accept, or cancel without penalty?",
  "b5.accept": "Accept",
  "b5.declineCancel": "Cancel, no penalty",
  "mf.start_at": "time",
  "mf.end_at": "end time",
  "mf.address": "address",
  "mf.maps_url": "location",
  "mf.programs": "program",
  "mf.terms": "terms",
  "mf.requirements": "requirements",
  "b5.late": "Late cancellation — under review",
  "b5.byVenue": "Cancelled by venue",
  "b5.eventCancelled": "Event cancelled",
  "b5.tabRequests": "New requests",
  "b5.tabConfirmed": "Confirmed",
  "b5.tabAll": "All",
  "b5.allEvents": "All events",
  "b5.external": "External booking",
  "b5.externalTitle": "Add external booking",
  "b5.externalNote": "For bookings you got by phone or in person. No platform fees apply",
  "b5.name": "Name",
  "b5.phone": "Phone",
  "b5.note": "Note",
  "b5.added": "Added",
  "b5.sourceExternal": "External",
  "b5.timeLeft": "{m} min left",
  "b5.approveChange": "Approve",
  "b5.rejectChange": "Decline change",
  "b5.changeReq": "Requests headcount change: {a} → {b}",
  "b5.confirmed": "Request confirmed",
  "b5.done": "Done",
  "b5.cancelEvent": "Cancel event",
  "b5.cancelEventNote": "All requests and bookings will be cancelled and customers notified, with no penalty to them",
  "b5.requestHint": "This is a booking request — the venue will contact you and confirm before the deadline",
  "b5.notConfirmed": "Booking isn't confirmed",
  "edit.areaEn": "Area (English)",
  "b5.pendingCount": "{n} requests waiting",
  "b5.empty": "No bookings here",
  "b6.booked": "Booked",
  "b6.arrived": "Arrived",
  "b6.remaining": "Remaining",
  "b6.arrivingNow": "Arriving now",
  "b6.record": "Record {n} arrival(s)",
  "b6.recorded": "Saved {n} arrival(s) — total {a} of {g}",
  "b6.allArrived": "Everyone arrived",
  "b6.saving": "Saving to the server…",
  "b6.delayed": "Delayed entry (after outage)",
  "b6.delayedNote": "Use only if the internet was down and you kept paper notes. Enter the real arrival time and the reason.",
  "b6.arrivedAt": "Actual arrival time",
  "b6.delayReason": "Reason for delayed entry",
  "b6.history": "Attendance log",
  "b6.late": "Delayed",
  "b6.checkName": "Check the booking name before entry — sharing a code doesn't prove identity",
  "b6.attendedOf": "Attended {a} of {g}",
  "b6.restrictedTitle": "Booking is restricted",
  "b6.restrictedMsg": "You have a no-show case that requires review by platform administration. Please submit a request explaining the reasons for your absence to restore booking access.",
  "b6.requestPh": "Explain the reason for your absence (at least 10 characters)",
  "b6.sendRequest": "Send request to admin",
  "b6.requestSent": "Request sent — the admin will review it",
  "b6.awaiting": "Your request reached the admin and awaits a decision. The restriction stays until then.",
  "b6.dispute": "Dispute",
  "b6.disputeTitle": "Dispute the attendance record",
  "b6.disputeSent": "Your dispute was sent to the admin",
  "b6.cases": "Cases & requests",
  "b6.kind.no_show": "No show",
  "b6.kind.dispute": "Dispute",
  "b6.cs.open": "Open",
  "b6.cs.awaiting_admin": "Awaiting decision",
  "b6.cs.approved": "Approved",
  "b6.cs.rejected": "Rejected",
  "b6.approve": "Approve & restore access",
  "b6.rejectCase": "Reject",
  "b6.decisionReason": "Decision reason",
  "b6.decided": "Decision recorded",
  "b6.from.customer": "Customer",
  "b6.from.venue": "Venue",
  "b6.noMessages": "The customer hasn't sent a request yet",
  "b6.activeTab": "Active",
  "b6.closedTab": "Closed",
  "b6.reversed": "Venue recorded a delayed entry after the case",
  "b6.restrictedUser": "Account restricted",
  "b6.decision": "Decision",
  "b6.newRequest": "New booking request!",
  "b6.expiring": "{n} request(s) expire in minutes",
  "b6.expiringOne": "{name} — {m} min left",
  "b6.review": "Review requests",
  "b6.soundOn": "Sound on",
  "b6.soundOff": "Sound off",
  "nav.dashboard": "Dashboard",
  "nav.finance": "Finance",
  "nav.audit": "Audit log",
  "b7.dashTitle": "Admin dashboard",
  "b7.dashSub": "A quick look at the platform today",
  "b7.venuesPending": "Venues awaiting approval",
  "b7.venuesApproved": "Approved venues",
  "b7.venuesSuspended": "Suspended venues",
  "b7.bkPending": "Requests awaiting confirmation",
  "b7.bkToday": "Bookings today",
  "b7.attendedToday": "Attended today",
  "b7.noShowToday": "No-shows today",
  "b7.openCases": "Open cases",
  "b7.restricted": "Restricted accounts",
  "b7.notifFailures": "Failed notifications",
  "b7.outstanding": "Outstanding",
  "b7.collected": "Collected",
  "b7.waived": "Waived",
  "b7.feesDue": "Fees due",
  "b7.recentAudit": "Recent activity",
  "b7.financeTitle": "Finance",
  "b7.financeSub": "Platform fees per venue — each currency separate, no conversion",
  "b7.balance": "Balance",
  "b7.noEntries": "No entries in this period",
  "b7.opening": "Opening balance",
  "b7.fees": "Fees due",
  "b7.debit_adj": "Debit adjustments",
  "b7.exemptions": "Approved exemptions",
  "b7.credit_adj": "Credit adjustments",
  "b7.payments": "Payments",
  "b7.closing": "Closing balance",
  "b7.formula": "Opening + fees + debit adj. − exemptions − credit adj. − payments = closing",
  "b7.from": "From",
  "b7.to": "To",
  "b7.apply": "Show",
  "b7.kind.fee": "Fee",
  "b7.kind.exemption": "Exemption",
  "b7.kind.debit_adj": "Debit adj.",
  "b7.kind.credit_adj": "Credit adj.",
  "b7.kind.payment": "Payment",
  "b7.note.launch_exemption": "Launch exemption",
  "b7.note.exempt": "Venue exemption",
  "b7.reversed": "Reversed",
  "b7.reversal": "Reversal",
  "b7.reverse": "Reverse",
  "b7.reverseTitle": "Reverse this entry",
  "b7.addPayment": "Record payment",
  "b7.addAdjust": "Adjustment",
  "b7.kindLabel": "Type",
  "b7.currency": "Currency",
  "b7.amount": "Amount",
  "b7.reason": "Reason / note",
  "b7.method": "Payment method",
  "b7.reference": "Reference",
  "b7.date": "Date",
  "b7.bookingRef": "Booking ID (optional)",
  "b7.otherCurrency": "Paid in another currency",
  "b7.settleCurrency": "Settlement currency",
  "b7.settleAmount": "Amount actually paid",
  "b7.rate": "Exchange rate",
  "b7.direction": "Rate direction (e.g. 1 USD = ... IQD)",
  "b7.approvedBy": "Approved by",
  "b7.save": "Save entry",
  "b7.saved": "Entry saved",
  "b7.settled": "Settled as",
  "b7.myFinance": "Platform fees",
  "b7.myFinanceSub": "Fees follow your model: per attended booking, per finished event (48 hours after it ends), or a monthly subscription.",
  "b7.feeRule": "Platform fee",
  "b7.since": "since",
  "b7.exemptRule": "Exempt",
  "b7.launchUntil": "Launch exemption runs until",
  "b7.noRule": "No fee set yet",
  "b7.launchTitle": "Launch exemption",
  "b7.launchNote": "Bookings, events and subscription months before this date owe zero fees. Changes apply to new items only.",
  "b7.endDate": "Last exempt day",
  "b7.launchSaved": "Exemption date saved",
  "b7.history": "History",
  "b7.auditTitle": "Audit log",
  "b7.auditSub": "Every sensitive action: who and when",
  "b7.todayList": "Today's bookings",
  "b7.todayEmpty": "No confirmed bookings today",
  "b7.open": "Open",
  "b7.checkBy": "Check in before {t} so it isn't recorded as a no-show",
  "b7.accounts": "Venues",
  "b7.total": "Total",
  "b7.pickAccount": "Pick a venue to see its statement",
  "b8.balanceTitle": "A friendly reminder about platform fees",
  "b8.balanceBody": "Your outstanding platform fee balance has reached:",
  "b8.viewStatement": "View statement",
  "b8.reminderTitle": "Outstanding balance reminder",
  "b8.reminderNote": "When a venue's outstanding balance reaches this amount or more, its owner sees a reminder banner. Leave empty to turn it off for that currency.",
  "b8.off": "Off",
  "b8.reminderSaved": "Reminder threshold saved",
  "b8.pdfTitle": "Platform fee statement",
  "b8.details": "Details",
  "b8.generated": "Issued",
  "b8.month": "Month",
  "b8.downloadPdf": "Download PDF",
  "b8.pdfReady": "Statement downloaded",
  "dp.pick": "Pick a date",
  "dp.clear": "Clear",
  "dp.today": "Today",
  "dp.prev": "Previous month",
  "dp.next": "Next month",
  "dp.hour": "Hour",
  "dp.minute": "Minute",
  "dp.period": "AM or PM",
  "dp.required": "Set the start and end date and time",
  "rc.receipt": "Receipt",
  "rc.no": "Receipt no.",
  "rc.venue": "Venue",
  "rc.by": "Recorded by",
  "rc.title": "Platform fee payment receipt",
  "rc.received": "Amount received",
  "rc.reversedNote": "This payment was later reversed",
  "rc.footer": "Receipt issued by Wayn Nrouh for a platform fee payment. Not a tax invoice.",
  "rc.download": "Receipt PDF",
  "rc.downloaded": "Receipt downloaded",
  "rc.failed": "Couldn't create the receipt file",
  "rc.resend": "Resend",
  "rc.saved": "Payment recorded and receipt sent to the venue",
  "rc.email.sent": "Emailed",
  "rc.email.sending": "Sending",
  "rc.email.partial": "Sent to some recipients",
  "rc.email.failed": "Sending failed",
  "rc.email.no_recipients": "No venue email",
  "et.sub": "Only you define types. Venue owners pick from this list and can't add or change them.",
  "et.readOnly": "Only the general manager can manage types.",
  "et.edit": "Edit type",
  "et.delete": "Delete type",
  "et.nameAr": "Arabic name",
  "et.nameEn": "English name",
  "et.slugHint": "Lowercase English letters and _ only; can't change after creating",
  "et.slugLocked": "The ID can't change after creating",
  "et.progLabelAr": "Program section name (Arabic)",
  "et.progLabelEn": "Program section name (English)",
  "et.editNote": "Changes apply to new events and future edits; published events stay as they are.",
  "et.created": "Type added",
  "et.updated": "Type saved",
  "et.count": "{n} events",
  "et.countFew": "{n} events",
  "et.inUse": "Can't delete: {n} events use it. You can turn it off instead.",
  "et.confirmDelete": "Delete the “{name}” type permanently?",
  "err.This type already exists": "This ID already exists; choose another",
  "err.This type is used by events": "Can't delete because events use it. Turn it off instead",
  "err.Type not found": "Type not found",
  "qr.button": "QR poster",
  "qr.eventButton": "QR poster",
  "qr.title": "Venue QR poster",
  "qr.hint": "The code opens your venue page on Wayn Nrouh so customers can see your events and book.",
  "qr.poster": "A4 poster",
  "qr.posterSub": "For a wall or door",
  "qr.cards": "Table cards",
  "qr.cardsSub": "4 cards on one A4 sheet; cut along the lines",
  "qr.scan": "امسح الكود واحجز",
  "qr.scanSub": "شوف فعالياتنا الجاية واحجز مكانك من موبايلك",
  "qr.downloaded": "File downloaded — print at actual size",
  "qr.failed": "Couldn't create the file",
  "qr.unpublished": "This venue is hidden; publish it to print a poster",
  "pinv.title": "Partner invite link",
  "pinv.sub": "Send it to any venue you want to join. It opens the registration page and the request comes to you for approval.",
  "pinv.whatsapp": "Send on WhatsApp",
  "pinv.qr": "Download QR code",
  "pinv.msg": "Hi! You're invited to join Wayn Nrouh as a partner and show your events to customers in Iraq. Register here:",
  "guide.title": "Welcome to Wayn Nrouh!",
  "guide.sub": "A few simple steps and your first event is in front of customers.",
  "guide.dismiss": "Hide guide",
  "guide.optional": "optional",
  "guide.logo": "Upload your logo",
  "guide.logoSub": "Shown when someone shares your venue link on WhatsApp",
  "guide.venue": "Add your venue",
  "guide.venueSub": "Name, address and map location",
  "guide.photos": "Add venue photos",
  "guide.photosSub": "Great photos bring more bookings",
  "guide.event": "Publish your first event",
  "guide.eventSub": "Set the date and price; it appears in Explore right away",
  "guide.team": "Add your team",
  "guide.teamSub": "A reception member confirms requests and records arrivals",
  "celebrate.title": "Congrats! Your first event is live",
  "celebrate.sub": "Customers can see it and book now. Share it to reach more people.",
  "celebrate.later": "Later",
  "fav.loginNeeded": "Sign in as a customer to save favourites",
  "review.button": "Rate your visit",
  "review.yours": "Your rating",
  "review.title": "How was your experience?",
  "review.sub": "Your rating helps others pick their next outing",
  "review.comment": "Write your thoughts (optional)",
  "review.submit": "Submit review",
  "review.saved": "Thanks! Your review was saved",
  "review.section": "Reviews",
  "review.none": "No reviews yet. Be the first to review after your visit",
  "review.count": "reviews",
  "review.new": "New",
  "invite.title": "{host} invited you out!",
  "invite.sub": "Book your spot on the same day and join the group",
  "invite.members": "in the group",
  "invite.people": "people",
  "invite.join": "Join & book",
  "invite.own": "This is your own invite — share it with friends",
  "invite.expired": "This invite has expired",
  "invite.notFound": "Invite not found",
  "invite.loginFirst": "Sign in & join",
  "invite.alreadyJoined": "You're already in this group — your ticket is in My Bookings",
  "invite.partnerNote": "Invites are for customer accounts",
  "invite.joined": "You joined the group! Your ticket is ready",
  "invite.dateLocked": "Group date",
  "group.chip": "Group",
  "share.inviteText": "Let's go out together! 🎉 I booked {venue} on {date}. Book with me and join the group:",
  "type.evening": "Evenings",
  "type.horse_riding": "Horse riding",
  "type.motorcycling": "Motorcycling",
  "type.arts": "Arts & workshops",
  "role.reception": "Reception",
  "role.finance": "Finance",
  "role.super": "Super admin",
  "auth.emailTab": "Email",
  "auth.googleTab": "Google",
  "auth.or": "or",
  "auth.loginTitle": "Sign in with email",
  "auth.signupTitle": "New account",
  "auth.signup": "Create account",
  "auth.haveCustomer": "Have an account? Sign in",
  "auth.newCustomer": "New here? Create an account",
  "auth.forgot": "Forgot password?",
  "auth.pwHint": "At least 8 characters",
  "forgot.title": "Forgot your password?",
  "forgot.sub": "Enter your email and we'll send you a reset link.",
  "forgot.send": "Send link",
  "forgot.sent": "If this email is registered, a reset link will arrive in a few minutes.",
  "forgot.blocked": "Note: the email service is not configured yet (blocked) — the link is only written to the server log for now.",
  "reset.title": "New password",
  "reset.sub": "Choose a strong password for your account.",
  "reset.submit": "Save password",
  "reset.done": "Password changed, please sign in",
  "reset.missing": "The link is incomplete or invalid",
  "profile.bookingName": "Booking name",
  "bd.title": "Booking details",
  "bd.sub": "Enter your official name and phone number. Bookings are made in your official name, and the venue sees it with your number.",
  "bd.name": "Official name",
  "bd.namePh": "e.g. Ali Hussein Kadhim",
  "bd.nameHint": "As on your ID, at least two names.",
  "bd.needed": "Before your first booking, add your official name and phone number. The booking is made in this name.",
  "bd.saved": "Booking details saved",
  "bd.edit": "Edit",
  "profile.bookingNameHint": "Venues see this name at reception; you can change it any time.",
  "profile.saveName": "Save name",
  "profile.nameSaved": "Name saved",
  "profile.signin": "Sign-in methods",
  "profile.google": "Google linked",
  "profile.passwordSet": "Password enabled",
  "phone.title": "Mobile number",
  "phone.sub": "Verify your number before sending any booking request.",
  "phone.placeholder": "07XX XXX XXXX",
  "phone.send": "Send code",
  "phone.resend": "Resend",
  "phone.code": "Verification code (6 digits)",
  "phone.verify": "Verify",
  "phone.verified": "Number verified",
  "phone.change": "Change number",
  "phone.sent": "We sent the code to",
  "phone.done": "Your number is verified",
  "phone.blocked": "SMS service is not configured yet (blocked). Test mode — code:",
  "booking.phoneNeeded": "Verify your mobile number first to send a booking request.",
  "booking.verifyNow": "Verify my number",
  "team.roleHint": "Owner: everything · Reception: bookings & attendance · Finance: bookings & financial summaries",
  "team.changeRole": "Change role",
  "team.roleChanged": "Role updated",
  "admin.team": "Admin team",
  "admin.teamSub": "Super admin: everything · Reception: bookings & venues follow-up · Finance: fees & accounts",
  "admin.addMember": "Add member",
  "admin.superOnly": "Approve/reject is for the super admin only",
  "settings.timezone": "Time zone",
  "settings.tzValue": "Baghdad (Asia/Baghdad)",
  "gov.baghdad": "Baghdad",
  "gov.basra": "Basra",
  "gov.nineveh": "Nineveh",
  "gov.erbil": "Erbil",
  "gov.sulaymaniyah": "Sulaymaniyah",
  "gov.duhok": "Duhok",
  "gov.halabja": "Halabja",
  "gov.kirkuk": "Kirkuk",
  "gov.anbar": "Anbar",
  "gov.babil": "Babil",
  "gov.karbala": "Karbala",
  "gov.najaf": "Najaf",
  "gov.wasit": "Wasit",
  "gov.diyala": "Diyala",
  "gov.saladin": "Saladin",
  "gov.qadisiyyah": "Al-Qadisiyyah",
  "gov.maysan": "Maysan",
  "gov.dhi_qar": "Dhi Qar",
  "gov.muthanna": "Muthanna",
  "reg.manager": "Account manager name",
  "reg.whatsapp": "WhatsApp number",
  "reg.governorate": "Governorate",
  "reg.area": "Area",
  "reg.address": "Short address",
  "reg.maps": "Google Maps link",
  "reg.logo": "Logo or venue photo",
  "reg.description": "Short description (optional)",
  "reg.chooseGov": "Choose governorate",
  "reg.logoHint": "JPG, PNG, WEBP or HEIC of any size — compressed automatically",
  "reg.logoNeeded": "Upload your logo so we can review your request",
  "reg.uploadLogo": "Upload logo",
  "reg.logoSaved": "Logo saved",
  "status.suspended": "Suspended",
  "suspended.title": "Your account is suspended",
  "suspended.body": "You can't publish or receive new requests right now. Existing bookings are kept and visible.",
  "status.reason": "Reason",
  "admin.suspend": "Suspend",
  "admin.reactivate": "Reactivate",
  "admin.reason": "Reason",
  "admin.reasonRequired": "Write the reason (required)",
  "admin.history": "Decision history",
  "admin.fee": "Platform fee model",
  "admin.feeAmount": "Amount",
  "admin.currency": "Currency",
  "admin.effective": "Effective date",
  "admin.exempt": "Fee exemption",
  "admin.exemptReason": "Exemption reason",
  "admin.exemptDays": "Exemption length in days (optional)",
  "admin.exemptUntil": "Fee-exempt until {date}",
  "admin.exemptForever": "Fee-exempt with no end date",
  "admin.exemptEnded": "Exemption ended on {date}",
  "admin.feeHint": "Pick one model for the partner. It applies from the moment you save.",
  "admin.feeCurrent": "Current fee",
  "admin.noFee": "No fee",
  "admin.changeFee": "Change fee",
  "admin.feeSaved": "Fee saved",
  "admin.done": "Action completed",
  "admin.maps": "Map location",
  "admin.manager": "Manager",
  "nav.events": "Events",
  "ev.openBadge": "Open for requests",
  "ev.closedBadge": "Requests closed",
  "ev.endedBadge": "Ended",
  "ev.cancelledBadge": "Cancelled",
  "ev.free": "Free",
  "ev.from": "From",
  "ev.perPerson": "per person",
  "ev.endsNextDay": "Ends the next day",
  "ev.details": "Details",
  "ev.request": "Send booking request",
  "ev.schedule": "Schedule",
  "ev.includes": "Price includes",
  "ev.separately": "Charged separately",
  "ev.requirements": "Participation requirements",
  "ev.terms": "Terms",
  "ev.cancelPolicy": "Cancellation allowed until",
  "ev.options": "Booking options",
  "ev.location": "Location",
  "ev.directions": "Directions",
  "ev.empty": "No events match your search right now",
  "ev.title": "Discover events",
  "ev.today": "Today",
  "ev.anyDate": "Any date",
  "ev.allGov": "All governorates",
  "ev.upcoming": "Upcoming events",
  "ev.noUpcoming": "No upcoming events at this venue",
  "ev.viewEvents": "See events",
  "ev.priceLabel": "Price",
  "ev.pricing.free": "Free entry",
  "ev.pricing.paid": "Paid entry",
  "ev.pricing.free_meal_optional": "Free entry, no mandatory meal",
  "ev.pricing.paid_no_meal": "Paid entry without a meal",
  "ev.pricing.free_meal_required": "Free entry with a meal order",
  "ev.pricing.paid_with_meal": "Paid entry including a meal",
  "aud.youth": "Youth",
  "aud.family": "Families",
  "cat.standard": "Standard",
  "cat.vip": "VIP",
  "prog.singer": "Singer",
  "prog.band": "Band",
  "prog.dj": "DJ",
  "prog.training": "Training",
  "prog.tour": "Tour",
  "prog.workshop": "Workshop",
  "prog.art_display": "Art display",
  "bk.option": "Choose an option",
  "bk.people": "Number of people",
  "bk.total": "Total",
  "bk.review": "Review the price and terms before sending",
  "bk.sent": "Request sent! Awaiting the venue's confirmation",
  "ve.title": "My events",
  "ve.sub": "Create events with schedules and prices; open or close requests any time",
  "ve.new": "New event",
  "ve.edit": "Edit",
  "ve.copy": "Copy to a new date",
  "ve.copyTitle": "Copy event",
  "ve.copyFrom": "Copy of “{title}”",
  "ve.copyHint": "All details and the poster are filled in, set to the same day and time a week later. Change the start if needed (the end moves with it), review, then save.",
  "ve.copyDates": "Choose dates",
  "ve.copied": "Copies created",
  "ve.open": "Open requests",
  "ve.close": "Close requests",
  "ve.saved": "Event saved",
  "ve.hiddenByAdmin": "Hidden by administration",
  "ve.f.venue": "Venue",
  "ve.f.type": "Event type",
  "ve.f.titleAr": "Event name (Arabic)",
  "ve.f.titleEn": "Event name (English)",
  "ve.f.poster": "Poster",
  "ve.f.shortAr": "Short description",
  "ve.f.details": "Details",
  "ve.f.start": "Start",
  "ve.f.end": "End",
  "ve.f.pricing": "Pricing model",
  "ve.f.price": "Price per person",
  "ve.f.addOption": "Add option",
  "ve.f.audience": "Audience",
  "ve.f.category": "Category",
  "ve.f.none": "—",
  "ve.f.addProgram": "Add program item",
  "ve.f.programName": "Item name",
  "ve.f.programTime": "Time (optional)",
  "ve.f.confirm": "Confirmation deadline (min)",
  "ve.f.grace": "Arrival grace period (min)",
  "ve.f.cancelCut": "Cancel deadline before grace end (min, optional)",
  "ve.f.maps": "Google Maps link (defaults to venue)",
  "ve.f.address": "Address",
  "ve.f.uploadPoster": "Upload poster",
  "ae.title": "Events & types",
  "ae.types": "Event types",
  "ae.active": "Active",
  "ae.inactive": "Inactive",
  "ae.options": "Audience/category options",
  "ae.meals": "Meals",
  "ae.programs": "Program types",
  "ae.hide": "Hide",
  "ae.unhide": "Unhide",
  "ae.hidden": "Hidden",
  "ae.events": "All events",
  "ae.newType": "New type",
  "ae.slug": "Slug (English)",
  "ve.f.conditions": "Option conditions (optional)",
  "lang.switch": "عربي",
  "nav.spots": "Public places",
  "spot.title": "Public places",
  "spot.sub": "Parks, corniches and squares you can visit without booking",
  "spot.empty": "No public spots here yet",
  "spot.legendSpot": "Public spot",
  "spot.legendVenue": "Bookable place",
  "spot.cat.park": "Park",
  "spot.cat.corniche": "Corniche",
  "spot.cat.square": "Square",
  "spot.cat.heritage": "Heritage site",
  "spot.cat.lake": "Lake & waterside",
  "spot.cat.other": "Other",
  "spot.noBooking": "This is a public spot open to everyone — no booking needed.",
  "spot.directions": "Directions",
  "spot.shareMsg": "Check out this place on Wayn Nrouh: {name}",
  "spot.adminTitle": "Public spots",
  "spot.adminSub": "Places open to visitors without booking",
  "spot.adminEmpty": "No public spots yet",
  "spot.add": "Add public spot",
  "spot.edit": "Edit public spot",
  "spot.confirmDelete": "Delete “{name}” permanently?",
  "spot.deleted": "Spot deleted",
  "spot.saved": "Spot saved",
  "spot.hidden": "Hidden",
  "spot.nameAr": "Arabic name",
  "spot.nameEn": "English name (optional)",
  "spot.category": "Category",
  "spot.governorate": "Governorate",
  "spot.area": "Area",
  "spot.address": "Address",
  "spot.hours": "Opening hours",
  "spot.description": "Description",
  "spot.photos": "Photos",
  "spot.location": "Location on map",
  "spot.pickHint": "Tap the map to set the location",
  "spot.visible": "Visible to customers",
  "spot.save": "Save",
  "spot.errName": "Enter the spot name",
  "spot.errLocation": "Pick the location on the map",
  "fav.tabSpots": "Public spots",
  "fav.emptySpots": "You haven't saved any public spots yet",
  "fav.loginNeededSpot": "Sign in to save public spots",
  "spot.km": "{n} km",
  "spot.nearMe": "Near me",
  "spot.noGeo": "Your device doesn't support location",
  "spot.geoDenied": "Couldn't get your location — allow location access and try again",
  "spot.featured": "Featured public spots",
  "spot.featuredSub": "Top rated and most saved by visitors",
  "spot.seeAll": "See all",
  "spot.tabSpots": "Public places",
  "spot.tabReviews": "Reviews",
  "rev.title": "Visitor ratings & tips",
  "rev.count": "{n} ratings",
  "rev.empty": "No ratings yet — be the first",
  "rev.login": "Sign in to rate",
  "rev.ask": "How was your visit?",
  "rev.tipPh": "A short tip for visitors (optional)",
  "rev.moderated": "Your rating appears after admin review",
  "rev.send": "Send",
  "rev.sent": "Thanks! It will appear after review",
  "rev.pickStars": "Pick a star rating",
  "rev.mine": "Your rating",
  "rev.edit": "Edit my rating",
  "rev.reason": "Reason",
  "rev.status.pending": "Pending review",
  "rev.status.approved": "Published",
  "rev.status.rejected": "Rejected",
  "rev.adminEmpty": "No reviews here",
  "rev.rejectPrompt": "Rejection reason (optional)",
  "rev.confirmDelete": "Delete this review permanently?",
  "rev.approve": "Approve",
  "rev.reject": "Reject",
  "rev.done.approve": "Review published",
  "rev.done.reject": "Review rejected",
  "rev.done.delete": "Review deleted",
  "nav.reviews": "Reviews",
  "er.title": "Attendee ratings",
  "er.venueTitle": "Ratings for this place's events",
  "er.empty": "No ratings yet",
  "er.rate": "Rate event",
  "er.yourRating": "Your rating {n}/5",
  "er.dialogTitle": "How was the event?",
  "er.commentPh": "Share your thoughts (optional)",
  "er.thanks": "Thanks, your rating was saved",
  "er.partnerTitle": "My event ratings",
  "er.partnerSub": "Feedback from customers who attended",
  "er.partnerEmpty": "No ratings yet. Customers can rate after their attendance is recorded",
  "er.adminTitle": "Event ratings",
  "sug.cta": "Know a nice public spot? Suggest it",
  "sug.title": "Suggest a public spot",
  "sug.hint": "The team will review it; if approved it becomes a public spot and you'll be notified.",
  "sug.send": "Send suggestion",
  "sug.sent": "Suggestion sent, thank you",
  "sug.mine": "My suggestions ({n})",
  "sug.status.pending": "Pending",
  "sug.status.approved": "Approved",
  "sug.status.rejected": "Rejected",
  "sug.tab": "Suggestions",
  "sug.adminEmpty": "No suggestions here",
  "sug.by": "by",
  "sug.approved": "Approved and added",
  "sug.rejected": "Suggestion rejected",
  "seat.title": "Available booking types",
  "seat.hint": "Pick the types that fit your event; customers choose one when booking. You can enable all.",
  "seat.general": "General",
  "seat.vip": "VIP",
  "seat.family": "Family",
  "seat.youth": "Youth",
  "seat.ladies": "Ladies",
  "seat.all": "Enable all",
  "seat.none": "Clear all",
  "seat.vipFee": "VIP extra fee",
  "seat.perPerson": "per person",
  "seat.perBooking": "per booking",
  "seat.vipHint": "Added on top of the event price when a customer picks VIP. Leave empty for no fee.",
  "seat.choose": "Choose a booking type",
  "seat.type": "Booking type",
  "seat.available": "Booking types",
  "top.label": "Top rated",
  "top.tip": "This event's place is rated {avg}/5 from {n} ratings",
  "img.title": "Uploaded image size",
  "img.note": "Every uploaded image (place photos, posters, public spots, suggestions) is resized and compressed to this limit at the best possible quality. Accepts JPG, PNG, WEBP and HEIC up to 40 MB.",
  "img.maxKb": "Max size (KB)",
  "img.maxSide": "Max side (px)",
  "img.saved": "Image limits saved; they apply to new uploads",
  "img.stats": "Stored images: {n} · total {mb} MB · above current limit: {over}",
  "img.recompress": "Compress existing images to the current limit",
  "img.running": "Compressing images…",
  "img.confirm": "All stored images larger than {kb} KB will be compressed. Continue?",
  "img.started": "Compression of existing images started",
  "img.progress": "Processed {done} of {total} · compressed {changed} · saved {mb} MB",
  "img.failed": "{n} failed",
  "err.Image can't be reduced to the size limit with acceptable quality": "Couldn't reduce the image to the limit with acceptable quality",
  "err.Only JPG, PNG, WEBP or HEIC images are allowed": "Only JPG, PNG, WEBP or HEIC images are allowed",
  "err.Image compression is already running": "Image compression is already running",
  "nav.choose": "Open location with",
  "nav.otherApps": "Other apps on my phone",
  "nav.copy": "Copy coordinates",
  "nav.copied": "Coordinates copied",
  "nav.hint": "If the app is installed it opens directly; otherwise it opens in the browser.",
  "nav.categories": "Categories",
  "cat.title": "Categories",
  "cat.sub": "All platform categories in one place. A category in use can only be deleted after its places or events are deleted.",
  "cat.tab.venues": "Place categories",
  "cat.tab.events": "Event categories",
  "cat.tab.spots": "Public spot categories",
  "sc.title": "Public spot categories",
  "sc.sub": "Shown to customers on public spots and when suggesting a spot",
  "sc.inUse": "Can't delete: used by {n} spots or suggestions",
  "sc.count": "{n} spots",
  "err.Choose a valid category": "Choose a valid category",
  "err.This category is used by public spots": "This category is used by public spots",
  "err.Image dimensions are too large": "Image dimensions are too large",
  "err.Cross-site request blocked": "Request blocked: it came from another site",
  "audit.reason": "Reason",
  "audit.today": "Today",
  "audit.yesterday": "Yesterday",
  "b7.filterAction": "Search by action or person",
  "la.confirmNotMeCust": "We'll sign this device out of your account. We recommend changing your password. Continue?",
  "la.signedOutCust": "That device was signed out. Change your password from your profile.",
  "cs.title": "What customers can see",
  "cs.note": "Choose which sections appear to customers in the app and on the home page. A hidden section disappears completely, including its bookings and favourites.",
  "cs.both": "Everything",
  "cs.bothNote": "Events, their venues and public spots",
  "cs.events": "Events only",
  "cs.eventsNote": "Events and bookable venues, no public spots",
  "cs.spots": "Public spots only",
  "cs.spotsNote": "No events or bookings",
  "cs.saved": "Customer sections saved",
  "err.Bookings are currently unavailable": "Bookings are currently unavailable",
  "la.title": "New sign-in to your account",
  "la.body": "Signed in from {device} on {time}.",
  "la.me": "This was me",
  "la.notMe": "Not me",
  "la.confirmNotMe": "We'll sign out every other device from your account; then change your password. Continue?",
  "la.signedOut": "Other devices signed out. Change your password now in Settings.",
  "err.This alert is for the device you are using now": "This alert is for the device you are using now",
  "err.Alert not found": "Alert not found",
  "dev.title": "My devices",
  "dev.sub": "Devices signed into your account. If you see one you don't know, sign it out and change your password.",
  "dev.empty": "No devices yet. They appear after your next sign-in.",
  "dev.current": "This device",
  "dev.last": "Last used {time}",
  "dev.signout": "Sign out",
  "dev.confirm": "Sign {device} out of your account?",
  "dev.done": "Device signed out",
  "rp.from": "Reply from {name}",
  "rp.reply": "Reply",
  "rp.edit": "Edit reply",
  "rp.delete": "Delete reply",
  "rp.publish": "Publish reply",
  "rp.placeholder": "Write your reply; everyone sees it under the rating",
  "rp.saved": "Reply published",
  "rp.confirmDelete": "Delete this reply?",
  "rp.adminDelete": "Delete partner reply",
  "rp.deleted": "Reply deleted",
  "err.Only a device you used before this sign-in can answer this alert": "Answer this alert from a device you used before this sign-in",
  "err.Write a reply": "Write a reply",
  "err.Device not found": "Device not found",
  "err.Use sign out for the device you are using now": "Use sign out for the device you are using now",
  "err.Only the owner can do this": "Only the owner can do this",
  "cx.headNoShow": "Customer missed an event — booking is paused",
  "cx.headDispute": "Attendance dispute",
  "cx.state.waitingCustomer": "Waiting for the customer to explain. They can't book until you decide; you can decide now.",
  "cx.state.awaiting_admin": "The customer sent an explanation and awaits your decision.",
  "cx.state.open": "Open, awaiting your decision.",
  "cx.state.approved": "Approved — the customer can book again.",
  "cx.state.rejected": "Rejected — the pause stays.",
  "cx.customer": "Customer",
  "cx.phone": "Phone",
  "cx.event": "Event",
  "cx.venue": "Place",
  "cx.date": "Event date",
  "cx.guests": "Guests",
  "cx.explain": "Customer's explanation",
  "cx.messages": "Messages",
  "cx.noExplain": "No explanation yet.",
  "cx.lift": "Lift the pause",
  "cx.liftHint": "The customer can book again",
  "cx.keep": "Keep the pause",
  "cx.keepHint": "Stays blocked and can send a new explanation",
  "cx.acceptHint": "Attendance is corrected in the customer's favour",
  "cx.rejectDispute": "Reject dispute",
  "cx.rejectHint": "Attendance stays as recorded",
  "b6.casesSub": "Review customers who missed events (booking paused automatically) and their disputes, then lift or keep the pause",
  "cx.short.waitingCustomer": "Awaiting reply",
  "cx.short.awaiting_admin": "Reply received",
  "cx.short.open": "Open",
  "cx.short.approved": "Pause lifted",
  "cx.short.rejected": "Pause kept",
  "cx.missed": "Missed",
  "cx.wa": "WhatsApp",
  "cx.waMsg": "Hello {name}, this is the «Wayn Nrouh» team. You didn't attend «{event}» on {date}, so booking on your account is paused. Could you tell us why so we can review it?",
  "apg.title": "Download or delete logs for a period",
  "apg.note": "Pick the period, download a copy (opens in Excel) if you want, then delete. Deletion is permanent and leaves no trace.",
  "apg.from": "From",
  "apg.to": "To",
  "apg.download": "Download copy",
  "apg.delete": "Delete logs",
  "apg.confirm": "{n} logs from {from} to {to} will be permanently deleted. Did you download a copy? Continue?",
  "apg.done": "{n} logs deleted",
  "apg.none": "No logs in this period",
  "apg.col.time": "Time",
  "apg.col.action": "Action",
  "apg.col.actor": "Person",
  "apg.col.role": "Role",
  "apg.col.target": "Target",
  "apg.col.id": "ID",
  "apg.col.details": "Details",
  "err.Choose valid dates": "Choose valid dates",
  "err.The start date must be before the end date": "The start date must be before the end date",
  "pc.exempt": "Exempt",
  "pc.wa": "WhatsApp",
  "pc.invite": "Invite a new partner",
  "pc.search": "Search by partner, phone or area",
  "pc.all": "All",
  "onb.skip": "Skip",
  "onb.next": "Next",
  "onb.prev": "Back",
  "onb.register": "Sign up now",
  "onb.browse": "Browse first",
  "onb.title": "Welcome screens",
  "onb.note": "Shown to visitors the first time they open the app, before signing up. Saving changes shows them again to all visitors.",
  "onb.slide": "Screen {n}",
  "onb.up": "Move up",
  "onb.down": "Move down",
  "onb.delete": "Delete screen",
  "onb.titleAr": "Title (Arabic)",
  "onb.bodyAr": "Text (Arabic)",
  "onb.english": "English text (optional)",
  "onb.titleEn": "English title",
  "onb.bodyEn": "English text",
  "onb.add": "Add screen",
  "onb.preview": "Preview",
  "onb.saved": "Welcome screens saved",
  "err.Upload the slide image from the app": "Upload the slide image from the app",
  "err.Title is required": "Title is required",
  "onb.needTitle": "Add a title for screen {n} before saving",
  "err.Each screen must have a unique id": "Duplicate screens found; remove the duplicate and try again",
  "hs.title": "Home page banner",
  "hs.note": "Title, description and rotating images at the top of the home page. Leave title or description empty to keep the default text.",
  "hs.titleAr": "Title (Arabic)",
  "hs.subAr": "Description (Arabic)",
  "hs.titleEn": "English title",
  "hs.subEn": "English description",
  "hs.images": "Rotating images (up to 8)",
  "hs.labelAr": "Arabic label, e.g. أمسيات",
  "hs.labelEn": "English label",
  "hs.delete": "Delete image",
  "hs.add": "Add image",
  "hs.interval": "Change every",
  "hs.seconds": "{n} seconds",
  "hs.saved": "Home banner saved",
  "hs.needImage": "Upload image {n} or remove it before saving",
  "err.Upload the image from the app": "Upload the image from the app",
  "err.Each image must have a unique id": "Duplicate images found; remove the duplicate and try again",
  "reg.more": "More options",
  "ap.search": "Search by place, partner or city",
  "bm.title": "Booking mode",
  "bm.open": "Open",
  "bm.openHint": "Takes unlimited bookings and only closes when you close it or at the time you set",
  "bm.single": "One-time",
  "bm.singleHint": "Closes automatically as soon as you accept one booking (e.g. whole-venue booking)",
  "bm.singleBadge": "One-time",
  "bm.repeat": "Repeat on consecutive days",
  "bm.repeatHint": "Number of days (1–30). One event per following day with the same time and details.",
  "bm.days": "days",
  "bm.until": "Last day: {d}",
  "ve.seriesSaved": "{n} events saved on consecutive days",
  "err.This one-time event is already booked": "This one-time event is already booked",
  "bm.skip": "Skip certain weekdays (tap a day to leave it out)",
  "bm.count": "{n} events will be created",
  "notif.extend": "Extend",
  "ve.extendFrom": "Extend the «{title}» series",
  "ve.extendHint": "Starts the day after the last event with the same time and details. Adjust days or skipped weekdays if needed, then save.",
  "ml.label": "Paste a Google Maps link",
  "ml.placeholder": "https://maps.app.goo.gl/…",
  "ml.paste": "Paste",
  "ml.go": "Locate",
  "ml.hint": "In Google Maps tap Share → Copy link, then paste it here. Coordinates like 33.31, 44.36 work too",
  "ml.done": "Location placed on the map",
  "ml.noClip": "Couldn't read the clipboard, paste the link manually",
  "err.Couldn't read a location from this link": "Couldn't read a location from this link. Make sure it's a Google Maps link to a specific place",
  "lm.button": "Use my current location",
  "lm.locating": "Finding your location…",
  "lm.done": "Your current location is on the map, check it and save",
  "dp.title": "Platform at a glance",
  "dp.customers": "Customers",
  "dp.partners": "Partners",
  "dp.places": "Published places",
  "dp.events": "Upcoming events",
  "dp.spots": "Public spots",
  "dp.week": "+{n} this week",
  "dp.active": "{n} active",
  "dp.suggest": "{n} suggestions waiting",
  "dp.hidden": "{n} hidden",
  "cl.tab.login": "Sign in",
  "cl.tab.register": "New account",
  "cl.registerTitle": "Create your account",
  "cl.registerSub": "All fields are required. After signing up, the platform team sends you a 6-digit activation code.",
  "cl.name": "Full name",
  "cl.phone": "Phone number",
  "cl.create": "Create account",
  "cl.registered": "Request received — wait for your activation code",
  "cl.otpTitle": "Activate account",
  "cl.otpSub": "Enter the activation code you received from the platform team",
  "cl.otpNote": "The Wayn Nrouh team will send a 6-digit code on WhatsApp to",
  "cl.activate": "Activate",
  "cl.activated": "Account activated, welcome!",
  "cl.resend": "Request a new code",
  "cl.resent": "New code requested",
  "cl.back": "Back",
  "cl.haveCode": "I have an activation code",
  "cl.needPhone": "Enter your phone number first",
  "cl.forceTitle": "Change your password",
  "cl.forceSub": "You signed in with a temporary password. Choose a new one to continue.",
  "nav.activations": "Activation",
  "rs.link": "Forgot password?",
  "rs.title": "Reset password",
  "rs.sub": "Request a code and the platform team will send it to you on WhatsApp",
  "rs.request": "Request reset code",
  "rs.requested": "Code requested — it will reach you on WhatsApp soon",
  "rs.haveCode": "I have a reset code",
  "rs.note": "The Wayn Nrouh team will send a 6-digit code on WhatsApp to",
  "rs.code": "Reset code",
  "rs.save": "Save new password",
  "rs.done": "Password changed and your other devices were signed out",
  "act.resets": "Forgot-password requests",
  "act.resetsNone": "No reset requests",
  "act.locked": "Code locked",
  "act.resetMsg": "Hi {name}, your Wayn Nrouh password reset code is: {code}\nIf you didn't request it, ignore this message.\n{site}/login",
  "dev.all": "Sign out all other devices",
  "dev.allConfirm": "Sign out every device except this one?",
  "dev.allDone": "Signed out {n} device(s)",
  "act.title": "Customer activation",
  "act.sub": "Send each new customer their activation code on WhatsApp. Codes stay valid until used, single use.",
  "act.pending": "Awaiting activation",
  "act.none": "No customers awaiting activation",
  "act.expired": "Code expired",
  "act.until": "Valid until {d}",
  "act.needNew": "Generate a new code",
  "act.attempts": "Wrong attempts: {n}",
  "act.send": "Send on WhatsApp",
  "act.renew": "New code",
  "act.renewed": "New code generated",
  "act.msg": "Hi {name}, your Wayn Nrouh activation code is: {code}\n{site}/login",
  "act.temps": "Temporary passwords for previous customers",
  "act.tempsNote": "Customers who used Google before. Send each one their temporary password; they change it on first sign-in.",
  "act.tempMsg": "Hi {name}, Wayn Nrouh now uses phone number and password.\nPhone: {phone}\nTemporary password: {pw}\nChange it after signing in.\n{site}/login",
  "reg.resetPwMsgCustomer": "Hi, your temporary Wayn Nrouh password is: {p}\nSign in with your phone number and change it.\n{site}/login",
  "err.Invalid phone number or password": "Invalid phone number or password",
  "err.Account not activated": "Account not activated yet",
  "err.This phone number is already registered": "This phone number is already registered — sign in",
  "err.Invalid or expired code": "Invalid or expired code",
  "err.Too many wrong codes. Request a new code": "Too many wrong codes. Request a new code",
  "err.Wait a minute before requesting a new code": "Wait a minute before requesting a new code",
  "err.Enter your full name": "Enter your full name",
  "err.Google sign-in is no longer available. Sign in with your phone number": "Google sign-in is no longer available",
  "reg.resetPwDoneCustomer": "Password changed. Send it to the customer on WhatsApp:",
  "err.This phone number is awaiting activation. Enter your activation code": "This number is awaiting activation. Enter your activation code",
  "err.Change your temporary password first": "Change your temporary password first",
};

export const strings: Record<"ar" | "en", Dict> = { ar, en };
